// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27160%27 height=%27160%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%27.85%27 numOctaves=%273%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;500;600;700&family=Instrument+Serif:ital@0;1&family=JetBrains+Mono:wght@400;500&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================================
 * Vriti AI Interview landing — scoped to .vx.
 * Warm paper, near-black ink, and green used only as a signal:
 * live, verified, passed, AI-active.
 * ========================================================================== */

.vx {
  --paper: #ffffff;
  --paper-2: #f3f4f6;
  --card: #ffffff;
  --ink: #111827;
  --ink-2: #374151;
  --mute: #6b7280;
  --line: rgba(17, 24, 39, 0.1);
  --line-2: rgba(17, 24, 39, 0.18);
  --sig: #4361ee;
  --sig-ink: #2e47c9;
  --sig-soft: rgba(67, 97, 238, 0.12);
  --sig-bright: #7b93ff;
  --warn: #c2791a;
  --night: #0f1117;
  --night-2: #171a21;
  --night-3: #1f232b;
  --night-line: rgba(255, 255, 255, 0.09);
  --night-text: #f3f4f6;
  --night-mute: rgba(243, 244, 246, 0.56);
  --f-sans: 'Inter Tight', 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  --f-serif: 'Instrument Serif', 'Times New Roman', serif;
  --f-mono: 'JetBrains Mono', ui-monospace, 'SFMono-Regular', Menlo, monospace;
  --gutter: clamp(16px, 4vw, 64px);
  --ease: cubic-bezier(0.16, 1, 0.3, 1);

  position: relative;
  background: var(--paper);
  color: var(--ink);
  font-family: var(--f-sans);
  font-size: 17px;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  overflow-x: clip;
}

/* Tailwind preflight is off app-wide, so reset inside the scope. :where()
   keeps these at zero specificity so component classes always win. */
.vx :where(*, *::before, *::after) {
  box-sizing: border-box;
}
.vx :where(h1, h2, h3, p, ol, ul, pre, figure) {
  margin: 0;
  padding: 0;
}
.vx :where(ol, ul) {
  list-style: none;
}
.vx :where(a) {
  color: inherit;
  text-decoration: none;
}
.vx :where(button) {
  font: inherit;
  color: inherit;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
}
.vx :where(mark) {
  background: none;
  color: inherit;
}
.vx :where(code, pre, kbd) {
  font-family: var(--f-mono);
}
.vx :where(img) {
  display: block;
}
.vx :focus-visible {
  outline: 2px solid var(--sig);
  outline-offset: 3px;
  border-radius: 6px;
}

/* Grain: one fixed, static layer. */
.vx::before {
  content: '';
  position: fixed;
  inset: 0;
  z-index: 60;
  pointer-events: none;
  opacity: 0.025;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* Lenis */
html.lenis,
html.lenis body {
  height: auto;
}
.lenis.lenis-smooth {
  scroll-behavior: auto !important;
}
.lenis.lenis-stopped {
  overflow: hidden;
}

.vx-sr {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
.vx-skip {
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 100;
  padding: 10px 16px;
  background: var(--ink);
  color: var(--paper) !important;
  border-radius: 8px;
  transform: translateY(-150%);
  transition: transform 0.2s;
}
.vx-skip:focus {
  transform: none;
}
.vx-fallback {
  min-height: 100vh;
}

/* ------------------------------- Type ----------------------------------- */

.vx-serif {
  font-family: var(--f-serif);
  font-style: italic;
  font-weight: 400;
  letter-spacing: -0.01em;
}
.vx-mono {
  font-family: var(--f-mono);
  font-size: 0.78em;
  letter-spacing: 0.02em;
}
.vx-muted {
  color: var(--mute);
}
.vx-sig {
  color: var(--sig-bright);
}
.vx-eyebrow,
.vx-kicker {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-family: var(--f-mono);
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--mute);
}
.vx-kicker--dark {
  color: var(--night-mute);
}
.vx-chapnum {
  display: inline-grid;
  place-items: center;
  min-width: 30px;
  height: 22px;
  padding: 0 6px;
  border: 1px solid currentColor;
  border-radius: 99px;
  font-size: 11px;
  opacity: 0.9;
}
.vx-h2 {
  font-size: clamp(2.4rem, 5.6vw, 5.6rem);
  line-height: 0.95;
  letter-spacing: -0.045em;
  font-weight: 600;
  text-wrap: balance;
}
.vx-h2 .vx-serif {
  letter-spacing: -0.02em;
}
.vx-h2--dark {
  color: var(--night-text);
}
.vx-h3 {
  font-size: clamp(1.7rem, 3vw, 2.8rem);
  line-height: 1.02;
  letter-spacing: -0.035em;
  font-weight: 600;
  text-wrap: balance;
}
.vx-body {
  max-width: 46ch;
  color: var(--ink-2);
  font-size: clamp(16px, 1.15vw, 18px);
  line-height: 1.55;
  text-wrap: pretty;
}
.vx-body--dark {
  color: var(--night-mute);
}
.vx-body--sm {
  font-size: 15px;
  color: var(--mute);
}

.vx-split {
  display: inline;
}
.vx-split__word {
  display: inline-block;
  overflow: hidden;
  vertical-align: top;
  padding-bottom: 0.08em;
  margin-bottom: -0.08em;
}
.vx-split__piece {
  display: inline-block;
  transform-origin: 0 100%;
  will-change: transform;
}

/* ------------------------------ Controls -------------------------------- */

.vx-magnetic {
  display: inline-flex;
}
.vx-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: 46px;
  padding: 0 20px;
  border-radius: 99px;
  background: var(--ink);
  color: var(--paper) !important;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  isolation: isolate;
  transition: transform 0.4s var(--ease);
}
.vx-btn::after {
  content: '';
  position: absolute;
  inset: 0;
  z-index: -1;
  background: var(--sig);
  transform: translateY(101%);
  border-radius: inherit;
  transition: transform 0.5s var(--ease);
}
.vx-btn:hover::after,
.vx-btn:focus-visible::after {
  transform: none;
}
.vx-btn__arrow {
  display: inline-block;
  transition: transform 0.4s var(--ease);
}
.vx-btn:hover .vx-btn__arrow {
  transform: translateX(4px);
}
.vx-btn--lg {
  height: 58px;
  padding: 0 28px;
  font-size: 17px;
}
.vx-btn--nav {
  height: 38px;
  padding: 0 16px;
  font-size: 14px;
}
.vx-btn--ghost {
  background: transparent;
  color: var(--ink) !important;
  box-shadow: inset 0 0 0 1px var(--line-2);
}
.vx-btn--sig {
  background: var(--sig);
  color: #fff !important;
}
.vx-btn--sig::after {
  background: var(--sig-ink);
}
.vx-link-arrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  padding: 8px 2px;
  background: linear-gradient(currentColor, currentColor) 0 100% / 0 1px no-repeat;
  transition: background-size 0.5s var(--ease);
}
.vx-link-arrow:hover {
  background-size: 100% 1px;
}
.vx-link-arrow--dark {
  color: var(--night-text);
}

.vx-dot {
  position: relative;
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--mute);
  flex: none;
}
.vx-dot--live,
.vx-dot--ok {
  background: var(--sig);
}
.vx-dot--live::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: inherit;
  animation: vx-ping 1.8s var(--ease) infinite;
}
.vx-dot--idle {
  background: var(--night-mute);
}
@keyframes vx-ping {
  0% {
    transform: scale(1);
    opacity: 0.6;
  }
  100% {
    transform: scale(3);
    opacity: 0;
  }
}
.vx-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 26px;
  padding: 0 11px;
  border-radius: 99px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.vx-pill--ok {
  background: var(--sig-soft);
  color: var(--sig-ink);
  box-shadow: inset 0 0 0 1px rgba(67, 97, 238, 0.25);
}
.vx-pill--lg {
  height: 36px;
  padding: 0 16px;
  font-size: 15px;
}
.vx-ok {
  color: var(--sig);
}
.vx-spark {
  color: var(--sig);
}

/* --------------------------------- Nav ---------------------------------- */

.vx-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  padding: 14px var(--gutter);
  transition: padding 0.5s var(--ease);
}
.vx-nav__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  height: 56px;
  padding: 0 10px 0 12px;
  border-radius: 18px;
  border: 1px solid transparent;
  transition:
    height 0.5s var(--ease),
    background-color 0.5s,
    border-color 0.5s,
    box-shadow 0.5s,
    color 0.4s;
}
.vx-nav.is-compact {
  padding-top: 10px;
}
.vx-nav.is-compact .vx-nav__bar {
  height: 50px;
  background: rgba(255, 255, 255, 0.78);
  border-color: var(--line);
  backdrop-filter: blur(14px) saturate(1.4);
  -webkit-backdrop-filter: blur(14px) saturate(1.4);
  box-shadow: 0 10px 30px -18px rgba(17, 24, 39, 0.3);
}
.vx-nav.is-dark .vx-nav__bar {
  color: var(--night-text);
}
.vx-nav.is-dark.is-compact .vx-nav__bar {
  background: rgba(23, 26, 33, 0.72);
  border-color: var(--night-line);
}
.vx-nav.is-dark .vx-btn--nav {
  background: var(--night-text);
  color: var(--night) !important;
}
.vx-nav__brand {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-weight: 600;
  letter-spacing: -0.02em;
}
.vx-nav__brand img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
.vx-nav__product {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  border-radius: 99px;
  box-shadow: inset 0 0 0 1px currentColor;
  font-size: 13px;
  opacity: 0.85;
}
.vx-nav__links {
  display: none;
  gap: 4px;
}
.vx-nav__link {
  position: relative;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.72;
  border-radius: 10px;
  transition:
    opacity 0.3s,
    background-color 0.3s;
}
.vx-nav__link:hover {
  opacity: 1;
  background: var(--line);
}
.vx-nav.is-dark .vx-nav__link:hover {
  background: var(--night-line);
}
/* Active page (e.g. Overview on /overview): a small signal underline. */
.vx-nav__link.is-active {
  opacity: 1;
}
.vx-nav__active {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 3px;
  height: 2px;
  border-radius: 2px;
  background: var(--sig);
}
.vx-nav.is-dark .vx-nav__active {
  background: var(--sig-bright);
}
.vx-menu__link.is-active {
  color: var(--sig-ink);
}
.vx-menu__here {
  margin-left: auto;
  align-self: center;
  font-family: var(--f-mono);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--sig);
}
.vx-nav__actions {
  display: flex;
  align-items: center;
  gap: 6px;
}
.vx-nav__login {
  display: none;
}
.vx-nav__menu {
  display: grid;
  place-content: center;
  gap: 5px;
  width: 40px;
  height: 40px;
  border-radius: 12px;
}
.vx-nav__menu span {
  display: block;
  width: 18px;
  height: 1.5px;
  background: currentColor;
  transition: transform 0.4s var(--ease);
}
.vx-nav.is-open .vx-nav__menu span:first-child {
  transform: translateY(3.25px) rotate(45deg);
}
.vx-nav.is-open .vx-nav__menu span:last-child {
  transform: translateY(-3.25px) rotate(-45deg);
}
.vx-menu {
  position: fixed;
  inset: 0;
  z-index: 45;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 110px var(--gutter) 32px;
  background: var(--paper);
}
.vx-menu nav {
  display: flex;
  flex-direction: column;
}
.vx-menu__link {
  display: flex;
  align-items: baseline;
  gap: 14px;
  padding: 14px 0;
  border-bottom: 1px solid var(--line);
  font-size: clamp(2rem, 9vw, 3rem);
  font-weight: 600;
  letter-spacing: -0.04em;
}
.vx-menu__link .vx-mono {
  font-size: 12px;
  color: var(--mute);
}
.vx-menu__actions {
  display: flex;
  gap: 10px;
}
.vx-menu__actions .vx-btn {
  flex: 1;
  justify-content: center;
}

@media (min-width: 640px) {
  .vx-nav__login {
    display: inline-flex;
  }
}
@media (min-width: 1024px) {
  .vx-nav__links {
    display: flex;
  }
  .vx-nav__menu {
    display: none;
  }
}

/* Chapter rail */
.vx-rail {
  position: fixed;
  left: 16px;
  top: 50%;
  z-index: 40;
  display: none;
  align-items: center;
  gap: 14px;
  transform: translateY(-50%);
  color: var(--ink);
  pointer-events: none;
  transition: color 0.4s;
}
.vx-rail.is-dark {
  color: var(--night-text);
}
.vx-rail ol {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.vx-rail li {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: var(--f-mono);
  font-size: 10px;
  opacity: 0.25;
  transition: opacity 0.4s;
}
.vx-rail li::before {
  content: '';
  width: 10px;
  height: 1px;
  background: currentColor;
  transition: width 0.5s var(--ease);
}
.vx-rail li span {
  display: none;
}
.vx-rail li.is-past {
  opacity: 0.5;
}
.vx-rail li.is-active {
  opacity: 1;
}
.vx-rail li.is-active::before {
  width: 22px;
  background: var(--sig);
}

.vx-rail__label {
  position: relative;
  overflow: hidden;
  height: 16px;
  width: 1px;
}
.vx-rail__label span {
  position: absolute;
  left: 0;
  top: 0;
  white-space: nowrap;
  font-family: var(--f-mono);
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  writing-mode: vertical-rl;
  display: none;
}
@media (min-width: 1280px) {
  .vx-rail {
    display: flex;
  }
}

/* ----------------------------- Story scenes ----------------------------- */

.vx-story {
  position: relative;
}
.vx-story[data-mode='scroll'] .vx-story__stage {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow: hidden;
}
.vx-story:not([data-mode='scroll']) .vx-story__stage {
  position: relative;
  padding: 112px 0 72px;
}
.vx-chapter {
  scroll-margin-top: 0;
}

/* --------------------------------- Hero --------------------------------- */

.vx-hero {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  height: 100%;
  padding: 0 var(--gutter);
}
.vx-story[data-mode='scroll'] .vx-hero {
  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
  gap: 2vw;
  padding-top: 70px;
}
.vx-hero__copy {
  position: relative;
  z-index: 2;
}
.vx-hero__title {
  display: flex;
  flex-direction: column;
  margin: 22px 0 28px;
  font-size: clamp(2.9rem, 7vw, 8.2rem);
  font-weight: 600;
  line-height: 0.86;
  letter-spacing: -0.06em;
}
.vx-hero__line {
  display: block;
}
.vx-hero__line.vx-serif {
  letter-spacing: -0.035em;
  color: var(--ink-2);
}
.vx-hero__lead {
  max-width: 34ch;
  font-size: clamp(17px, 1.35vw, 21px);
  line-height: 1.45;
  color: var(--ink-2);
  text-wrap: pretty;
}
.vx-hero__ctas {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 18px 26px;
  margin-top: 34px;
}
.vx-hero__stage {
  position: relative;
  aspect-ratio: 1;
  width: min(100%, 82vh);
  justify-self: center;
  margin-top: 40px;
}
.vx-story[data-mode='scroll'] .vx-hero__stage {
  margin-top: 0;
}
.vx-hero__orb {
  position: absolute;
  inset: 6%;
}
.vx-orb {
  display: block;
  width: 100%;
  height: 100%;
}
.vx-sat {
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 13px;
  color: var(--ink-2);
}
.vx-sat__k {
  font-family: var(--f-mono);
  font-size: 10.5px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--mute);
}
.vx-sat__v {
  font-family: var(--f-mono);
  font-size: 14px;
  color: var(--ink);
}
.vx-sat--status {
  top: 3%;
  left: 50%;
  transform: translateX(-50%);
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-radius: 99px;
  background: var(--card);
  box-shadow:
    inset 0 0 0 1px var(--line),
    0 12px 30px -20px rgba(17, 24, 39, 0.4);
  font-family: var(--f-mono);
  font-size: 12px;
  letter-spacing: 0.14em;
  color: var(--ink);
  white-space: nowrap;
}
.vx-sat--timer {
  top: 16%;
  right: 0;
  text-align: right;
}
.vx-sat--transcript {
  left: -6%;
  top: 36%;
  width: 46%;
  max-width: 270px;
  padding: 14px 16px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow:
    inset 0 0 0 1px var(--line),
    0 20px 40px -28px rgba(17, 24, 39, 0.45);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}
.vx-sat--transcript p {
  font-family: var(--f-serif);
  font-style: italic;
  font-size: clamp(17px, 1.5vw, 22px);
  line-height: 1.2;
  color: var(--ink);
}
.vx-sat__bars {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.vx-minibar {
  display: grid;
  grid-template-columns: 1fr;
  gap: 3px;
  font-size: 12px;
}
.vx-minibar i {
  display: block;
  height: 3px;
  border-radius: 3px;
  background: var(--sig);
  transform-origin: left;
}
.vx-sat--objective {
  right: -2%;
  bottom: 26%;
  width: 40%;
  max-width: 220px;
  text-align: right;
  align-items: flex-end;
}
.vx-sat--objective .vx-sat__v {
  font-family: var(--f-sans);
  font-size: 14px;
  font-weight: 500;
}
.vx-coverage {
  display: flex;
  gap: 4px;
  margin-top: 4px;
}
.vx-coverage i {
  width: 22px;
  height: 3px;
  border-radius: 3px;
  background: var(--line-2);
  transition: background-color 0.5s;
}
.vx-coverage i.is-on {
  background: var(--ink);
}
.vx-coverage i.is-now {
  background: var(--sig);
}
.vx-sat--code {
  left: 4%;
  bottom: 12%;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  border-radius: 10px;
  box-shadow: inset 0 0 0 1px var(--line-2);
  background: rgba(255, 255, 255, 0.7);
}
.vx-sat__glyph {
  color: var(--sig);
}
.vx-sat--report {
  z-index: 2;
  left: 50%;
  top: 50%;
  translate: -50% -50%;
  align-items: center;
  gap: 10px;
  padding: 22px 26px;
  border-radius: 22px;
  background: var(--card);
  box-shadow:
    inset 0 0 0 1px var(--line),
    0 30px 60px -30px rgba(17, 24, 39, 0.45);
}
.vx-sat__score {
  font-size: 64px;
  font-weight: 600;
  letter-spacing: -0.05em;
  line-height: 0.9;
  color: var(--ink);
}
.vx-sat__score small {
  font-size: 18px;
  color: var(--mute);
  letter-spacing: 0;
}
.vx-wave {
  position: absolute;
  left: 18%;
  right: 18%;
  bottom: 1%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  --amp: 0.35;
}
.vx-wave i {
  width: 2px;
  height: 100%;
  border-radius: 2px;
  background: var(--ink);
  opacity: 0.6;
  transform: scaleY(calc(var(--h) * var(--amp)));
  animation: vx-wave 1.1s ease-in-out infinite alternate;
  transition: background-color 0.5s;
}
.vx-wave.is-speaking {
  --amp: 1;
}
.vx-wave.is-speaking i {
  background: var(--sig);
  opacity: 0.9;
}
.vx-wave.is-evaluating {
  --amp: 0.12;
}
.vx-wave.is-ready {
  --amp: 0.06;
}
@keyframes vx-wave {
  from {
    transform: scaleY(calc(var(--h) * var(--amp) * 0.25));
  }
  to {
    transform: scaleY(calc(var(--h) * var(--amp)));
  }
}
.vx-hero__foot {
  position: absolute;
  left: var(--gutter);
  right: var(--gutter);
  bottom: 22px;
  display: none;
  justify-content: space-between;
  font-size: 13px;
  color: var(--mute);
}
.vx-story[data-mode='scroll'] .vx-hero__foot {
  display: flex;
}

@media (max-width: 959px) {
  .vx-hero__stage {
    width: min(100%, 520px);
  }
  .vx-sat--transcript {
    left: 0;
  }
  .vx-sat--objective {
    right: 0;
  }
}
@media (max-width: 520px) {
  .vx-sat--transcript p {
    font-size: 15px;
  }
  .vx-sat--objective,
  .vx-sat--timer {
    font-size: 12px;
  }
  .vx-sat--code {
    display: none;
  }
}

/* --------------------------------- Flow --------------------------------- */

.vx-chapter--flow {
  background: var(--paper);
  border-top: 1px solid var(--line);
}
.vx-flow {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: 0 var(--gutter);
}
.vx-flow__ticker {
  position: absolute;
  left: 0;
  bottom: 2%;
  display: flex;
  gap: 2vw;
  white-space: nowrap;
  font-size: clamp(4.5rem, 10vw, 11rem);
  font-weight: 600;
  letter-spacing: -0.06em;
  line-height: 1;
  color: transparent;
  -webkit-text-stroke: 1px var(--line-2);
  pointer-events: none;
  will-change: transform;
}
.vx-flow__ticker span {
  display: inline-flex;
  gap: 2vw;
  transition:
    -webkit-text-stroke-color 0.5s,
    color 0.5s;
}
.vx-flow__ticker span.is-on {
  color: rgba(67, 97, 238, 0.07);
  -webkit-text-stroke-color: rgba(67, 97, 238, 0.4);
}
.vx-flow__ticker em {
  font-style: normal;
}
.vx-story:not([data-mode='scroll']) .vx-flow__ticker {
  display: none;
}
.vx-story[data-mode='scroll'] .vx-flow {
  padding-bottom: 14vh;
}
.vx-flow__grid {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  align-items: center;
}
.vx-flow__copy .vx-h2 {
  margin: 18px 0 32px;
  max-width: 11ch;
}
.vx-flow__station {
  min-height: 140px;
  padding-top: 18px;
  border-top: 1px solid var(--line-2);
}
.vx-flow__num {
  font-family: var(--f-mono);
  font-size: 12px;
  color: var(--sig);
}
.vx-flow__station h3 {
  margin: 6px 0 8px;
  font-size: clamp(1.6rem, 2.6vw, 2.4rem);
  font-weight: 600;
  letter-spacing: -0.03em;
}
.vx-flow__station p {
  color: var(--ink-2);
  max-width: 36ch;
}
.vx-flow__visual {
  display: grid;
  place-items: center;
  min-height: 360px;
}
.vx-morph {
  position: relative;
  width: 400px;
  height: 320px;
  transform: scale(var(--morph-scale, 0.82));
}
.vx-atom {
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  will-change: transform;
}
.vx-atom i {
  position: absolute;
  inset: 0;
  border-radius: inherit;
}
.vx-atom.is-wave i {
  background: inherit;
  animation: vx-atomwave 0.9s ease-in-out infinite alternate;
}
.vx-atom.is-wave {
  background: transparent !important;
  overflow: visible;
}
@keyframes vx-atomwave {
  from {
    transform: scaleY(0.45);
  }
  to {
    transform: scaleY(1);
  }
}
.vx-atom.is-wave i {
  background: var(--ink);
}
.vx-atom.is-wave:nth-child(5) i,
.vx-atom.is-wave:nth-child(6) i,
.vx-atom.is-wave:nth-child(7) i {
  background: var(--sig);
}
.vx-morph__lines {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  fill: none;
  stroke: var(--line-2);
  stroke-width: 1.5;
}
.vx-morph__score {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  font-size: 84px;
  font-weight: 600;
  letter-spacing: -0.06em;
  line-height: 1;
}
.vx-morph__score small {
  position: absolute;
  top: 64%;
  font-size: 15px;
  letter-spacing: 0;
  color: var(--mute);
}
.vx-flow__rail {
  margin-top: 36px;
}
.vx-flow__track {
  position: relative;
  height: 1px;
  background: var(--line-2);
}
.vx-flow__track i {
  position: absolute;
  inset: 0;
  background: var(--sig);
  transform-origin: left;
}
.vx-story:not([data-mode='scroll']) .vx-flow__track {
  display: none;
}
.vx-flow__rail ol {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-top: -5px;
}
.vx-flow__rail li {
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 12px;
  color: var(--mute);
  transition: color 0.4s;
}
.vx-flow__rail li b {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--paper);
  box-shadow: inset 0 0 0 1.5px var(--line-2);
  transition:
    background-color 0.4s,
    box-shadow 0.4s,
    transform 0.4s;
}
.vx-flow__rail li.is-past {
  color: var(--ink);
}
.vx-flow__rail li.is-past b {
  background: var(--ink);
  box-shadow: none;
}
.vx-flow__rail li.is-on b {
  background: var(--sig);
  transform: scale(1.4);
}
@media (min-width: 960px) {
  .vx-flow__grid {
    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  }
  .vx-morph {
    --morph-scale: 1.15;
  }
}
@media (min-width: 1400px) {
  .vx-morph {
    --morph-scale: 1.35;
  }
}
@media (max-width: 640px) {
  .vx-flow__rail li span {
    display: none;
  }
  .vx-flow__visual {
    min-height: 290px;
  }
  .vx-morph {
    --morph-scale: 0.78;
  }
}

/* -------------------------- Split scenes (Job) --------------------------- */

.vx-chapter--job {
  background: var(--paper);
}
.vx-split-scene {
  display: grid;
  grid-template-columns: 1fr;
  gap: 48px;
  align-items: center;
  height: 100%;
  padding: 0 var(--gutter);
}
.vx-split-scene__copy .vx-h2 {
  margin: 18px 0 22px;
  max-width: 12ch;
}
.vx-modes {
  display: grid;
  margin-top: 32px;
  border-top: 1px solid var(--line);
}
.vx-modes li {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid var(--line);
  color: var(--mute);
}
.vx-modes li.is-on {
  color: var(--ink);
}
.vx-modes li.is-on .vx-modes__title::before {
  content: '✦ ';
  color: var(--sig);
}
.vx-modes__title {
  font-weight: 600;
}
.vx-modes__note {
  font-size: 14px;
}
.vx-split-scene__visual {
  position: relative;
  padding: 86px 3vw 86px 0;
}
.vx-window {
  position: relative;
  border-radius: 18px;
  background: var(--card);
  box-shadow:
    inset 0 0 0 1px var(--line),
    0 40px 80px -50px rgba(17, 24, 39, 0.55);
  overflow: hidden;
}
.vx-window__chrome {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 38px;
  padding: 0 14px;
  border-bottom: 1px solid var(--line);
  font-size: 12px;
  color: var(--mute);
}
.vx-window__chrome i {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--line-2);
}
.vx-window__chrome span {
  margin-left: 10px;
}
.vx-stepper {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  padding: 16px 18px;
  border-bottom: 1px solid var(--line);
}
.vx-stepper li {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--mute);
  min-width: 0;
}
.vx-stepper li span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vx-stepper b {
  display: grid;
  place-items: center;
  flex: none;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 11px;
  box-shadow: inset 0 0 0 1px var(--line-2);
  transition:
    background-color 0.4s,
    color 0.4s;
}
.vx-stepper li.is-on {
  color: var(--ink);
  font-weight: 600;
}
.vx-stepper li.is-on b {
  background: var(--ink);
  color: var(--paper);
  box-shadow: none;
}
.vx-stepper li.is-done b {
  background: var(--sig);
  color: #fff;
  box-shadow: none;
}
.vx-wizard__body {
  padding: 18px;
  min-height: 340px;
}
.vx-aiprompt {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px 12px;
  align-items: center;
  padding: 14px;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(67, 97, 238, 0.06), transparent);
  box-shadow: inset 0 0 0 1px rgba(67, 97, 238, 0.25);
}
.vx-aiprompt__label {
  grid-column: 1 / -1;
  font-size: 12px;
  font-weight: 600;
  color: var(--sig-ink);
}
.vx-aiprompt__field {
  min-height: 42px;
  font-size: 14px;
  line-height: 1.45;
}
.vx-aiprompt__go {
  align-self: end;
  padding: 7px 12px;
  border-radius: 9px;
  background: var(--ink);
  color: var(--paper);
  font-size: 12px;
  font-weight: 600;
}
.vx-aiprompt__go.is-busy {
  background: var(--sig);
}
.vx-typed--caret > span:first-child::after {
  content: '';
  display: inline-block;
  width: 1.5px;
  height: 1.05em;
  margin-left: 1px;
  vertical-align: -0.15em;
  background: var(--sig);
  animation: vx-blink 1s steps(1) infinite;
}
@keyframes vx-blink {
  50% {
    opacity: 0;
  }
}
.vx-jd {
  position: relative;
  margin-top: 16px;
  display: grid;
  gap: 8px;
}
.vx-jd__title {
  font-weight: 600;
  font-size: 17px;
  letter-spacing: -0.02em;
}
.vx-jd__line {
  font-size: 14px;
  line-height: 1.6;
  color: var(--ink-2);
}
.vx-jd__skeleton {
  position: absolute;
  inset: 30px 0 0;
  background: repeating-linear-gradient(180deg, var(--line) 0 8px, transparent 8px 22px);
  opacity: 0.7;
  border-radius: 4px;
}
.vx-extract {
  padding: 0 2px;
  border-radius: 4px;
  background-image: linear-gradient(var(--sig-soft), var(--sig-soft));
  background-size: 0% 100%;
  background-repeat: no-repeat;
  transition:
    background-size 0.7s var(--ease),
    color 0.4s,
    box-shadow 0.4s;
}
.vx-extract.is-lit {
  background-size: 100% 100%;
  color: var(--sig-ink);
  box-shadow: inset 0 -1.5px 0 var(--sig);
}
.vx-prefill__note {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
  font-size: 13px;
  color: var(--sig-ink);
  font-weight: 600;
}
.vx-field {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  margin-bottom: 8px;
  border-radius: 10px;
  box-shadow: inset 0 0 0 1px var(--line);
  font-size: 14px;
}
.vx-field span {
  color: var(--mute);
}
.vx-range {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 14px;
  font-size: 12px;
  color: var(--mute);
}
.vx-range div {
  position: relative;
  flex: 1;
  height: 4px;
  border-radius: 4px;
  background: var(--line);
}
.vx-range i {
  position: absolute;
  left: 30%;
  width: 15%;
  top: -2px;
  height: 8px;
  border-radius: 8px;
  background: var(--ink);
}
.vx-extracted {
  pointer-events: none;
}
.vx-chip {
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 14px;
  border-radius: 12px;
  background: var(--ink);
  color: var(--paper);
  box-shadow: 0 20px 40px -24px rgba(17, 24, 39, 0.7);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}
.vx-chip__k {
  font-family: var(--f-mono);
  font-size: 10px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--sig-bright);
}
.vx-chip--0 {
  top: 8px;
  left: 4%;
}
.vx-chip--1 {
  top: 26px;
  right: 0;
}
.vx-chip--2 {
  bottom: 8px;
  left: 10%;
}
.vx-chip--3 {
  bottom: 22px;
  right: 6%;
}
@media (min-width: 960px) {
  .vx-split-scene {
    grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
    gap: 6vw;
    padding-top: 40px;
  }
}
@media (max-width: 640px) {
  .vx-stepper li span {
    display: none;
  }
  .vx-stepper li.is-on span {
    display: inline;
  }
  .vx-stepper {
    grid-template-columns: auto auto auto 1fr;
  }
  .vx-chip {
    position: relative;
    inset: auto !important;
    display: inline-flex;
    margin: 8px 8px 0 0;
  }
  .vx-split-scene__visual {
    padding: 0;
  }
}

/* ------------------------- Configure surface ---------------------------- */

.vx-chapter--config {
  background: var(--paper-2);
}
.vx-config {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 22px;
  height: 100%;
  padding: 0 var(--gutter);
}
.vx-story[data-mode='scroll'] .vx-config {
  padding-top: 60px;
}
.vx-config__head .vx-h3 {
  margin-top: 12px;
}
.vx-readout {
  position: relative;
  height: clamp(2.4rem, 5.6vw, 5.4rem);
  overflow: hidden;
  font-family: var(--f-mono);
  font-weight: 500;
  font-size: clamp(1.25rem, 4.6vw, 4.6rem);
  letter-spacing: -0.04em;
  line-height: 1.15;
}
.vx-readout span {
  position: absolute;
  left: 0;
  top: 0;
  white-space: nowrap;
}
.vx-surface {
  display: grid;
  grid-template-columns: 1fr;
  gap: 28px;
  padding: 26px;
  border-radius: 24px;
  background: var(--paper);
  box-shadow:
    inset 0 0 0 1px var(--line),
    inset 0 2px 0 rgba(255, 255, 255, 0.7),
    0 30px 60px -40px rgba(17, 24, 39, 0.4);
}
.vx-surface__col {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.vx-surface__col--hw {
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
.vx-ctl {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.vx-ctl__label {
  display: block;
  font-family: var(--f-mono);
  font-size: 10.5px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--mute);
}
.vx-seg {
  display: flex;
  padding: 4px;
  border-radius: 12px;
  background: var(--paper-2);
  box-shadow: inset 0 1px 2px rgba(17, 24, 39, 0.08);
}
.vx-seg__opt {
  position: relative;
  flex: 1;
  padding: 9px 8px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: var(--mute);
  transition: color 0.3s;
  white-space: nowrap;
}
.vx-seg__opt span {
  position: relative;
  z-index: 1;
}
.vx-seg__opt.is-on {
  color: var(--paper);
}
.vx-seg__thumb {
  position: absolute;
  inset: 0;
  border-radius: 9px;
  background: var(--ink);
  box-shadow: 0 6px 14px -8px rgba(17, 24, 39, 0.7);
}
.vx-switch {
  display: flex;
  align-items: center;
  gap: 14px;
}
.vx-switch__track {
  position: relative;
  flex: none;
  width: 46px;
  height: 26px;
  border-radius: 99px;
  background: var(--line-2);
  transition: background-color 0.4s;
}
.vx-switch__track i {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 6px rgba(17, 24, 39, 0.25);
}
.vx-switch.is-on .vx-switch__track {
  background: var(--sig);
}
.vx-switch__hint {
  display: block;
  font-size: 13px;
  color: var(--mute);
  margin-top: 2px;
}
.vx-dial {
  position: relative;
  display: grid;
  justify-items: center;
  gap: 8px;
}
.vx-dial svg {
  width: 132px;
  height: 132px;
  transform: rotate(-90deg);
}
.vx-dial circle {
  fill: none;
  stroke-width: 8;
}
.vx-dial__bg {
  stroke: var(--paper-2);
}
.vx-dial__fg {
  stroke: var(--ink);
  stroke-linecap: round;
}
.vx-dial line {
  stroke: var(--line-2);
  stroke-width: 2;
}
.vx-dial__v {
  position: absolute;
  top: 66px;
  left: 50%;
  transform: translate(-50%, -50%);
  display: grid;
  justify-items: center;
  overflow: hidden;
  height: 52px;
}
.vx-dial__v strong {
  font-size: 34px;
  font-weight: 600;
  letter-spacing: -0.04em;
  line-height: 1;
}
.vx-dial__v span {
  font-size: 11px;
  color: var(--mute);
}
.vx-fader {
  display: grid;
  justify-items: center;
  gap: 10px;
}
.vx-fader__track {
  position: relative;
  width: 10px;
  height: 140px;
  border-radius: 10px;
  background: var(--paper-2);
  box-shadow: inset 0 1px 3px rgba(17, 24, 39, 0.12);
}
.vx-fader__fill {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: var(--sig);
  transform-origin: bottom;
}
.vx-fader__pos {
  position: absolute;
  inset: 0;
}
.vx-fader__thumb {
  position: absolute;
  left: 50%;
  top: 0;
  translate: -50% -50%;
  padding: 4px 8px;
  border-radius: 8px;
  background: var(--ink);
  color: var(--paper);
  font-family: var(--f-mono);
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 6px 14px -6px rgba(17, 24, 39, 0.6);
}
.vx-voice__row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0 4px;
  font-size: 14px;
}
.vx-voice__play {
  display: grid;
  place-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--ink);
  color: var(--paper);
  font-size: 10px;
}
.vx-voice__wave {
  display: flex;
  align-items: center;
  gap: 2px;
  height: 22px;
  margin-left: auto;
}
.vx-voice__wave i {
  width: 2px;
  height: 100%;
  border-radius: 2px;
  background: var(--sig);
  animation: vx-atomwave 0.7s ease-in-out infinite alternate;
}
.vx-agenda {
  display: grid;
  gap: 10px;
}
.vx-agenda__head {
  display: flex;
  justify-content: space-between;
}
.vx-agenda__bar {
  display: flex;
  gap: 4px;
  height: 52px;
}
.vx-agenda__blk {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-radius: 10px;
  overflow: hidden;
  font-size: 12px;
  font-weight: 600;
  min-width: 0;
}
.vx-agenda__blk em {
  font-style: normal;
  white-space: nowrap;
  position: relative;
  z-index: 1;
}
.vx-agenda__blk.is-voice {
  background: var(--ink);
  color: var(--paper);
}
.vx-agenda__blk.is-code {
  background: repeating-linear-gradient(135deg, var(--sig-soft) 0 6px, transparent 6px 12px),
    var(--card);
  box-shadow: inset 0 0 0 1px rgba(67, 97, 238, 0.4);
  color: var(--sig-ink);
}
.vx-agenda__branches {
  position: absolute;
  right: 10px;
  top: 8px;
  bottom: 8px;
  display: flex;
  gap: 6px;
  align-items: flex-end;
}
.vx-agenda__branches b {
  width: 3px;
  height: 100%;
  border-radius: 3px;
  background: var(--sig-bright);
  transform-origin: bottom;
}
.vx-agenda__branches b:nth-child(2) {
  height: 70%;
}
.vx-agenda__branches b:nth-child(3) {
  height: 45%;
}
.vx-agenda__legend {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 22px;
  font-size: 13px;
  color: var(--mute);
}
.vx-agenda__legend span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.vx-agenda__legend i {
  width: 10px;
  height: 10px;
  border-radius: 3px;
}
.vx-agenda__legend .is-voice {
  background: var(--ink);
}
.vx-agenda__legend .is-code {
  background: var(--sig-soft);
  box-shadow: inset 0 0 0 1px var(--sig);
}
.vx-agenda__legend .is-follow {
  background: var(--sig-bright);
  width: 3px;
}
@media (min-width: 960px) {
  .vx-surface {
    grid-template-columns: 1.15fr 0.85fr 1fr;
    gap: 36px;
    padding: 30px 34px;
  }
}

/* ------------------------------ Blueprint ------------------------------- */

.vx-chapter--blueprint {
  background: var(--paper);
}
.vx-blueprint {
  display: grid;
  grid-template-columns: 1fr;
  gap: 36px;
  height: 100%;
  align-content: center;
  padding: 0 var(--gutter);
}
.vx-story[data-mode='scroll'] .vx-blueprint {
  padding-top: 70px;
  grid-template-columns: minmax(0, 0.62fr) minmax(0, 1.38fr);
  gap: 4vw;
  align-items: center;
}
.vx-blueprint__copy .vx-h2 {
  margin: 18px 0 26px;
  font-size: clamp(2.2rem, 4.4vw, 4.6rem);
}
.vx-blueprint__caption {
  min-height: 70px;
  padding-top: 16px;
  border-top: 1px solid var(--line-2);
  color: var(--ink-2);
}
.vx-blueprint__caption .vx-mono {
  color: var(--sig);
  margin-right: 6px;
}
.vx-blueprint__board {
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
  align-items: start;
}
.vx-blueprint__link {
  display: none;
}
@media (min-width: 960px) {
  .vx-blueprint__board {
    grid-template-columns: minmax(0, 0.85fr) 40px minmax(0, 1.15fr);
  }
  .vx-blueprint__link {
    display: block;
    align-self: center;
    height: 1px;
    background: var(--line);
  }
  .vx-blueprint__link i {
    display: block;
    height: 100%;
    background: var(--sig);
    transform-origin: left;
  }
}
.vx-criteria,
.vx-tree {
  padding: 20px;
  border-radius: 20px;
  background: var(--card);
  box-shadow: inset 0 0 0 1px var(--line);
  transform-origin: left center;
}
.vx-criteria__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
.vx-tag {
  display: inline-flex;
  padding: 4px 9px;
  border-radius: 99px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
}
.vx-tag--ai {
  background: var(--sig-soft);
  color: var(--sig-ink);
}
.vx-tag--edit {
  background: var(--paper-2);
  color: var(--ink-2);
}
.vx-criteria__list {
  display: grid;
  gap: 16px;
}
.vx-criteria__row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.vx-criteria__name {
  font-family: var(--f-mono);
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.vx-criteria__w {
  position: relative;
  display: inline-flex;
  align-items: baseline;
  overflow: hidden;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: -0.04em;
  line-height: 1;
}
.vx-criteria__w small {
  font-size: 14px;
  color: var(--mute);
}
.vx-criteria__bar {
  height: 6px;
  margin: 8px 0 6px;
  border-radius: 6px;
  background: var(--paper-2);
  overflow: hidden;
}
.vx-criteria__bar i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: var(--ink);
  transform-origin: left;
}
.vx-criteria__list li.is-top .vx-criteria__bar i {
  background: var(--sig);
}
.vx-criteria__ind {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  font-size: 12px;
  color: var(--mute);
}
.vx-tree__list {
  display: grid;
  gap: 12px;
}
.vx-tree__node {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  background: var(--ink);
  color: var(--paper);
}
.vx-tree__id {
  font-family: var(--f-mono);
  font-size: 11px;
  opacity: 0.6;
  white-space: nowrap;
}
.vx-tree__title {
  font-weight: 600;
  font-size: 14px;
}
.vx-tree__w {
  margin-left: auto;
  font-family: var(--f-mono);
  font-size: 13px;
  color: var(--sig-bright);
}
.vx-tree__obj > ol {
  display: grid;
  gap: 6px;
  margin: 6px 0 0 18px;
  padding-left: 14px;
  border-left: 1px solid var(--line-2);
}
.vx-tree__sub {
  position: relative;
}
.vx-tree__sub::before {
  content: '';
  position: absolute;
  left: -14px;
  top: 17px;
  width: 12px;
  height: 1px;
  background: var(--line-2);
}
.vx-tree__subnode {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 7px 10px;
  border-radius: 9px;
  box-shadow: inset 0 0 0 1px var(--line-2);
  font-size: 13px;
  font-weight: 500;
}
.vx-tree__subnode .vx-tree__id {
  opacity: 1;
  color: var(--mute);
}
.vx-tree__q {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  overflow: hidden;
  padding: 0 4px 0 10px;
  font-size: 13px;
  color: var(--ink-2);
}
.vx-tree__q > * {
  margin-top: 7px;
}
.vx-tree__qmark {
  flex: none;
  font-family: var(--f-mono);
  font-size: 11px;
  color: var(--sig);
}
.vx-tree__eval {
  flex: none;
  margin-left: auto;
  padding: 2px 7px;
  border-radius: 6px;
  background: var(--sig-soft);
  color: var(--sig-ink);
  font-family: var(--f-mono);
  font-size: 10.5px;
  white-space: nowrap;
}
.vx-tree__total {
  display: flex;
  justify-content: space-between;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px dashed var(--line-2);
  font-size: 13px;
  color: var(--mute);
}
.vx-tree__total strong {
  font-family: var(--f-mono);
  font-weight: 500;
  color: var(--ink);
}
@media (max-width: 640px) {
  .vx-tree__eval {
    display: none;
  }
}

/* ------------------------------ Interview ------------------------------- */

.vx-chapter--interview,
.vx-chapter--coding {
  background: var(--night);
}
.vx-chapter--interview {
  background: var(--paper);
}
.vx-story:not([data-mode='scroll']).vx-chapter--interview {
  background: var(--night);
}
.vx-room {
  position: relative;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 28px;
  align-content: center;
  padding: 0 var(--gutter);
  background: radial-gradient(80% 60% at 30% 40%, #182040, var(--night) 70%);
  color: var(--night-text);
  overflow: hidden;
  will-change: transform;
}
.vx-story[data-mode='scroll'] .vx-room {
  grid-template-columns: minmax(0, 0.58fr) minmax(0, 1.42fr);
  grid-template-rows: 1fr auto;
  gap: 18px 4vw;
  padding-top: 84px;
  padding-bottom: 28px;
}
.vx-room__intro {
  align-self: center;
}
.vx-room__intro .vx-h2 {
  margin: 18px 0 22px;
  font-size: clamp(2.2rem, 4.4vw, 4.6rem);
}
.vx-room__facts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 22px;
  font-size: 13px;
  color: var(--night-mute);
}
.vx-story[data-mode='scroll'] .vx-room__facts {
  grid-column: 1 / -1;
  border-top: 1px solid var(--night-line);
  padding-top: 16px;
}
.vx-room__facts li::before {
  content: '— ';
  color: var(--sig-bright);
}
.vx-meet {
  position: relative;
  display: grid;
  grid-template-rows: auto 1fr auto auto;
  gap: 12px;
  min-height: 0;
  padding: 14px;
  border-radius: 22px;
  background: var(--night-2);
  box-shadow:
    inset 0 0 0 1px var(--night-line),
    0 50px 100px -40px rgba(0, 0, 0, 0.8);
}
.vx-story[data-mode='scroll'] .vx-meet {
  height: min(72vh, 680px);
  align-self: center;
}
.vx-meet__top {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 12px;
  color: var(--night-mute);
}
.vx-meet__role {
  display: none;
}
.vx-meet__q {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 6px 12px;
  border-radius: 99px;
  background: var(--night-3);
  color: var(--night-text);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vx-meet__q .vx-mono {
  color: var(--sig-bright);
}
.vx-meet__meta {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  white-space: nowrap;
}
.vx-meet__timer {
  font-size: 13px;
  color: var(--night-text);
}
.vx-rec {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--f-mono);
  font-size: 11px;
  letter-spacing: 0.1em;
  color: #ff6b5e;
}
.vx-rec i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  animation: vx-blink 1.4s steps(1) infinite;
}
.vx-rec--light {
  color: #d1453b;
}
.vx-conn {
  display: inline-flex;
  align-items: flex-end;
  gap: 2px;
}
.vx-conn i {
  width: 3px;
  border-radius: 1px;
  background: var(--sig-bright);
  transition: background-color 0.3s;
}
.vx-conn i:nth-child(1) {
  height: 5px;
}
.vx-conn i:nth-child(2) {
  height: 8px;
}
.vx-conn i:nth-child(3) {
  height: 11px;
  margin-right: 5px;
}
.vx-conn.is-bad i {
  background: var(--warn);
}
.vx-conn.is-bad i:nth-child(n + 2) {
  background: var(--night-line);
}
.vx-meet__main {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  min-height: 0;
}
.vx-tile {
  position: relative;
  border-radius: 16px;
  background: var(--night-3);
  overflow: hidden;
  box-shadow: inset 0 0 0 1px var(--night-line);
}
.vx-tile--ai {
  min-height: 260px;
  transition: box-shadow 0.5s;
}
.vx-tile--ai.is-speaking {
  box-shadow:
    inset 0 0 0 1px rgba(123, 147, 255, 0.35),
    0 0 60px -20px rgba(123, 147, 255, 0.35);
}
.vx-tile--ai .vx-orb {
  position: absolute;
  inset: 8%;
  width: 84%;
  height: 84%;
}
.vx-tile__label {
  position: absolute;
  left: 12px;
  bottom: 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  border-radius: 99px;
  background: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  color: var(--night-text);
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
}
.vx-meet__side {
  display: none;
  grid-template-rows: auto 1fr;
  gap: 12px;
  min-height: 0;
}
.vx-tile--cam {
  aspect-ratio: 4 / 3;
}
.vx-cam {
  display: block;
  width: 100%;
  height: 100%;
}
.vx-cam__box {
  fill: none;
  stroke: var(--sig-bright);
  stroke-width: 1.5;
}
.vx-chat {
  display: flex;
  flex-direction: column;
  min-height: 0;
  border-radius: 16px;
  background: var(--night-3);
  box-shadow: inset 0 0 0 1px var(--night-line);
  overflow: hidden;
}
.vx-chat__head {
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
  border-bottom: 1px solid var(--night-line);
  font-size: 12px;
  color: var(--night-mute);
}
.vx-chat__list {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 8px;
  flex: 1;
  min-height: 0;
  padding: 12px;
  overflow: hidden;
}
.vx-bubble {
  max-width: 88%;
  padding: 8px 11px;
  border-radius: 12px;
  font-size: 12.5px;
  line-height: 1.4;
}
.vx-bubble.is-ai {
  align-self: flex-start;
  background: rgba(123, 147, 255, 0.1);
  color: var(--night-text);
  border-bottom-left-radius: 4px;
}
.vx-bubble.is-cand {
  align-self: flex-end;
  background: rgba(255, 255, 255, 0.08);
  color: var(--night-text);
  border-bottom-right-radius: 4px;
}
.vx-bubble.is-status {
  align-self: center;
  background: none;
  color: var(--warn);
  font-family: var(--f-mono);
  font-size: 11px;
}
.vx-captions {
  min-height: 64px;
}
.vx-captions__line {
  font-size: clamp(16px, 1.6vw, 22px);
  line-height: 1.35;
  letter-spacing: -0.01em;
}
.vx-captions__line.is-ai {
  color: var(--night-text);
}
.vx-captions__line.is-cand {
  color: rgba(243, 244, 246, 0.8);
}
.vx-captions__who {
  margin-right: 10px;
  font-family: var(--f-mono);
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--sig-bright);
}
.vx-captions__line.is-cand .vx-captions__who {
  color: var(--night-mute);
}
.vx-meet__controls {
  display: flex;
  justify-content: center;
  gap: 8px;
}
.vx-ctrl {
  padding: 8px 14px;
  border-radius: 99px;
  background: var(--night-3);
  font-size: 12px;
  color: var(--night-mute);
}
.vx-ctrl--end {
  background: #c2392f;
  color: #fff;
}
.vx-drop {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  border-radius: inherit;
  background: rgba(15, 17, 23, 0.62);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
}
.vx-drop__card {
  display: grid;
  justify-items: center;
  gap: 8px;
  max-width: 280px;
  padding: 22px 26px;
  border-radius: 18px;
  background: var(--night-2);
  box-shadow: inset 0 0 0 1px var(--night-line);
  text-align: center;
  font-size: 13px;
  color: var(--night-mute);
}
.vx-drop__card strong {
  font-size: 18px;
  color: var(--night-text);
}
.vx-drop__spin {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 2px solid var(--night-line);
  border-top-color: var(--warn);
  animation: vx-spin 0.9s linear infinite;
}
@keyframes vx-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (min-width: 760px) {
  .vx-meet__main {
    grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr);
  }
  .vx-meet__side {
    display: grid;
  }
}
@media (min-width: 1200px) {
  .vx-meet__role {
    display: inline;
  }
}

/* -------------------------------- Coding -------------------------------- */

.vx-coding {
  position: relative;
  display: grid;
  gap: 24px;
  height: 100%;
  align-content: center;
  padding: 0 var(--gutter);
  color: var(--night-text);
  background: radial-gradient(70% 60% at 80% 60%, #162042, var(--night) 70%);
}
.vx-story[data-mode='scroll'] .vx-coding {
  grid-template-columns: minmax(0, 0.5fr) minmax(0, 1.5fr);
  grid-template-rows: 1fr auto;
  gap: 18px 3vw;
  padding-top: 84px;
  padding-bottom: 28px;
}
.vx-coding__intro {
  align-self: center;
}
.vx-coding__intro .vx-h2 {
  margin: 18px 0 22px;
  font-size: clamp(2.2rem, 4.2vw, 4.4rem);
}
.vx-coding__langs {
  font-family: var(--f-mono);
  font-size: 12px;
  color: var(--night-mute);
  letter-spacing: 0.04em;
}
.vx-story[data-mode='scroll'] .vx-coding__langs {
  grid-column: 1 / -1;
  padding-top: 16px;
  border-top: 1px solid var(--night-line);
}
.vx-workspace {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  align-self: center;
}
.vx-problem {
  display: none;
  flex-direction: column;
  gap: 12px;
  padding: 18px;
  border-radius: 18px;
  background: var(--night-2);
  box-shadow: inset 0 0 0 1px var(--night-line);
  font-size: 13.5px;
  color: var(--night-mute);
}
.vx-problem h3 {
  font-size: 19px;
  letter-spacing: -0.02em;
  color: var(--night-text);
}
.vx-problem code {
  color: var(--sig-bright);
  font-size: 12.5px;
}
.vx-problem__meta b {
  color: var(--warn);
  font-weight: 600;
}
.vx-problem__io {
  display: grid;
  gap: 5px;
  padding: 12px;
  border-radius: 10px;
  background: var(--night-3);
  font-size: 11px;
}
.vx-problem__io code {
  color: var(--night-text);
  font-size: 11.5px;
}
.vx-problem__hint span {
  font-weight: 600;
  color: var(--night-text);
}
.vx-problem__hint p {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition:
    max-height 0.5s var(--ease),
    opacity 0.4s;
}
.vx-problem__hint.is-open p {
  max-height: 40px;
  opacity: 1;
  margin-top: 4px;
}
.vx-workspace__editor {
  min-width: 0;
  transform-origin: left center;
}
.vx-editor {
  position: relative;
  border-radius: 18px;
  background: #0d1016;
  box-shadow:
    inset 0 0 0 1px var(--night-line),
    0 40px 80px -40px rgba(0, 0, 0, 0.9);
  overflow: visible;
  transition: filter 0.6s;
}
.vx-editor.is-submitted {
  filter: saturate(0.6) brightness(0.8);
}
.vx-editor__bar {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 44px;
  padding: 0 12px;
  border-bottom: 1px solid var(--night-line);
  font-size: 12px;
  color: var(--night-mute);
}
.vx-editor__file {
  font-family: var(--f-mono);
}
.vx-lang {
  position: relative;
  padding: 5px 10px;
  border-radius: 8px;
  background: var(--night-3);
  color: var(--night-text);
}
.vx-lang__menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  display: grid;
  width: 150px;
  padding: 6px;
  border-radius: 12px;
  background: var(--night-3);
  box-shadow:
    inset 0 0 0 1px var(--night-line),
    0 20px 40px -10px rgba(0, 0, 0, 0.8);
  transform-origin: top left;
}
.vx-lang__menu li {
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  color: var(--night-mute);
}
.vx-lang__menu li.is-on {
  background: rgba(123, 147, 255, 0.14);
  color: var(--sig-bright);
}
.vx-editor__timer {
  margin-left: auto;
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  color: var(--night-text);
}
.vx-editor__timer .vx-mono {
  font-size: 13px;
}
.vx-editor__submit {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  background: var(--sig-bright);
  color: var(--night);
  font-weight: 600;
}
.vx-editor__submit kbd {
  font-size: 10px;
  opacity: 0.6;
}
.vx-editor__submit.is-done {
  background: var(--night-3);
  color: var(--sig-bright);
}
.vx-code {
  padding: 14px 0;
  overflow: hidden;
  font-size: clamp(11px, 0.9vw, 13.5px);
  line-height: 1.75;
  color: #e5e7eb;
}
.vx-code__ln {
  display: flex;
  gap: 14px;
  padding-right: 14px;
  opacity: 0;
  transform: translateX(-6px);
  transition:
    opacity 0.25s,
    transform 0.4s var(--ease);
  white-space: pre;
}
.vx-code__ln.is-on {
  opacity: 1;
  transform: none;
}
.vx-code__ln.is-caret code::after {
  content: '';
  display: inline-block;
  width: 7px;
  height: 1.1em;
  vertical-align: -0.2em;
  background: var(--sig-bright);
  animation: vx-blink 1s steps(1) infinite;
}
.vx-code__no {
  flex: none;
  width: 34px;
  text-align: right;
  color: rgba(255, 255, 255, 0.22);
}
.vx-code code {
  font-size: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
}
.t-kw {
  color: #9db0ff;
}
.t-fn {
  color: #7ad7ff;
}
.t-str {
  color: #cbd5e1;
}
.t-cm {
  color: #6b7280;
  font-style: italic;
}
.vx-editor__pip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px 14px;
  font-size: 11px;
  color: var(--night-mute);
}
.vx-review {
  position: relative;
  padding: 18px;
  border-radius: 18px;
  background: rgba(23, 26, 33, 0.92);
  box-shadow:
    inset 0 0 0 1px rgba(123, 147, 255, 0.3),
    0 40px 80px -30px rgba(0, 0, 0, 0.9);
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}
.vx-review__head {
  margin-bottom: 12px;
  font-family: var(--f-mono);
  font-size: 12px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--sig-bright);
}
.vx-review ul {
  display: grid;
  gap: 10px;
}
.vx-review li {
  position: relative;
  padding-left: 18px;
  font-size: 13.5px;
  line-height: 1.45;
  color: var(--night-text);
}
.vx-review li::before {
  position: absolute;
  left: 0;
  font-family: var(--f-mono);
}
.vx-review li.is-good::before {
  content: '+';
  color: var(--sig-bright);
}
.vx-review li.is-note::before {
  content: '?';
  color: var(--warn);
}
.vx-review__follow {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-top: 16px;
  padding: 12px;
  border-radius: 14px;
  background: rgba(123, 147, 255, 0.08);
}
.vx-review__orb {
  flex: none;
  width: 56px;
  height: 56px;
}
.vx-review__who {
  font-family: var(--f-mono);
  font-size: 10.5px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--sig-bright);
}
.vx-review__follow p {
  margin-top: 2px;
  font-family: var(--f-serif);
  font-style: italic;
  font-size: 19px;
  line-height: 1.2;
}
@media (min-width: 960px) {
  .vx-workspace {
    grid-template-columns: minmax(0, 0.6fr) minmax(0, 1.4fr);
  }
  .vx-problem {
    display: flex;
  }
  .vx-review {
    position: absolute;
    right: 0;
    top: 6%;
    width: min(48%, 420px);
  }
}

/* -------------------------------- Context ------------------------------- */

.vx-chapter--context {
  background: var(--paper);
}
.vx-context {
  display: grid;
  gap: 36px;
  height: 100%;
  align-content: center;
  padding: 0 var(--gutter);
}
.vx-story[data-mode='scroll'] .vx-context {
  grid-template-columns: minmax(0, 0.62fr) minmax(0, 1.38fr);
  gap: 4vw;
  align-items: center;
  padding-top: 60px;
}
.vx-context__copy .vx-h2 {
  margin: 18px 0 22px;
  font-size: clamp(2.2rem, 4.4vw, 4.6rem);
}
.vx-observe {
  position: relative;
  min-height: 420px;
}
.vx-observe__timeline {
  padding: 20px;
  border-radius: 22px;
  background: var(--card);
  box-shadow:
    inset 0 0 0 1px var(--line),
    0 40px 80px -60px rgba(17, 24, 39, 0.5);
  transform-origin: 50% 50%;
}
.vx-observe__rec {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--line);
  font-size: 13px;
}
.vx-observe__speed {
  margin-left: auto;
  font-size: 12px;
  color: var(--mute);
}
.vx-observe__qs {
  position: relative;
  height: 28px;
  margin: 10px 0 2px calc(var(--label-w, 150px));
}
.vx-observe__qs span {
  position: absolute;
  top: 6px;
  font-family: var(--f-mono);
  font-size: 10.5px;
  color: var(--mute);
  translate: -50% 0;
}
.vx-observe__tracks {
  position: relative;
  display: grid;
  gap: 6px;
  --label-w: 150px;
}
.vx-track {
  display: grid;
  grid-template-columns: var(--label-w, 150px) 1fr;
  align-items: center;
  min-height: 40px;
}
.vx-track__label {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}
.vx-track__label b {
  font-family: var(--f-mono);
  font-size: 11.5px;
  font-weight: 500;
  letter-spacing: 0.1em;
}
.vx-track__label small {
  font-size: 11.5px;
  color: var(--mute);
}
.vx-track__lane {
  position: relative;
  height: 24px;
  border-radius: 6px;
  background: repeating-linear-gradient(90deg, var(--line) 0 1px, transparent 1px 10%);
  transform-origin: left;
  container-type: inline-size;
}
.vx-track__seg {
  position: absolute;
  top: 8px;
  height: 8px;
  border-radius: 8px;
  background: var(--ink);
  opacity: calc(1 - var(--k, 0));
}
.vx-track__mark {
  position: absolute;
  left: 0;
  top: 3px;
  width: 3px;
  height: 18px;
  border-radius: 3px;
  background: var(--warn);
  transform: translateX(calc((var(--x) * 1cqw) * (1 - var(--k, 0)) + 50cqw * var(--k, 0)));
}
.vx-observe__playlane {
  position: absolute;
  top: -6px;
  bottom: -6px;
  left: var(--label-w, 150px);
  right: 0;
  container-type: inline-size;
  pointer-events: none;
}
.vx-observe__playhead {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 2px;
  background: var(--sig);
  box-shadow: 0 0 12px var(--sig);
}
.vx-verdict {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  text-align: center;
  pointer-events: none;
}
.vx-verdict__word {
  font-size: clamp(3.6rem, 9vw, 9rem);
  font-weight: 600;
  letter-spacing: -0.06em;
  line-height: 0.85;
  text-transform: uppercase;
}
.vx-verdict__counts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px 26px;
  margin-top: 6px;
}
.vx-verdict__counts li {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: var(--mute);
}
.vx-verdict__counts strong {
  font-size: 26px;
  font-weight: 600;
  letter-spacing: -0.03em;
  color: var(--ink);
}
.vx-verdict__note {
  max-width: 44ch;
  font-size: 13px;
  color: var(--mute);
}
@media (max-width: 640px) {
  .vx-observe__tracks {
    --label-w: 96px;
  }
  .vx-observe__qs {
    margin-left: 96px;
  }
  .vx-track__label small,
  .vx-observe__speed {
    display: none;
  }
  .vx-observe {
    min-height: 470px;
  }
}

/* ------------------------------- Evidence ------------------------------- */

.vx-chapter--evidence {
  background: var(--paper);
}
.vx-evidence {
  position: relative;
  height: 100%;
  padding: 0 var(--gutter);
}
.vx-story:not([data-mode='scroll']) .vx-evidence {
  display: grid;
  gap: 24px;
}
.vx-evidence__intro {
  position: absolute;
  left: var(--gutter);
  top: 92px;
  z-index: 2;
}
.vx-evidence__intro .vx-h2 {
  margin-top: 14px;
  max-width: 13ch;
  font-size: clamp(2rem, 4vw, 4rem);
}
.vx-story:not([data-mode='scroll']) .vx-evidence__intro {
  position: relative;
  left: auto;
  top: auto;
}
.vx-evidence__field {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.vx-story:not([data-mode='scroll']) .vx-evidence__field {
  display: none;
}
.vx-particles {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}
.vx-bigscore {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  font-size: min(42vw, 78vh);
  font-weight: 600;
  letter-spacing: -0.07em;
  line-height: 1;
  color: var(--ink);
}
.vx-bigscore small {
  position: absolute;
  right: 18%;
  bottom: 22%;
  font-size: 3vw;
  letter-spacing: 0;
  color: var(--mute);
}
.vx-report {
  position: absolute;
  left: var(--gutter);
  right: var(--gutter);
  top: 84px;
  bottom: 28px;
  display: flex;
  flex-direction: column;
  border-radius: 24px;
  background: var(--card);
  box-shadow:
    inset 0 0 0 1px var(--line),
    0 60px 120px -60px rgba(17, 24, 39, 0.6);
  overflow: hidden;
  transform-origin: 50% 100%;
}
.vx-story:not([data-mode='scroll']) .vx-report {
  position: relative;
  inset: auto;
}
.vx-report__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px 18px;
  padding: 18px 22px;
  border-bottom: 1px solid var(--line);
}
.vx-avatar {
  display: grid;
  place-items: center;
  flex: none;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--ink);
  color: var(--paper);
  font-weight: 600;
  font-size: 14px;
}
.vx-avatar--sm {
  width: 32px;
  height: 32px;
  font-size: 12px;
}
.vx-report__who {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.vx-report__who strong {
  font-size: 17px;
  letter-spacing: -0.02em;
}
.vx-report__who span {
  font-size: 13px;
  color: var(--mute);
}
.vx-sample {
  padding: 3px 8px;
  border-radius: 6px;
  background: var(--paper-2);
  font-family: var(--f-mono);
  font-size: 10.5px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--mute);
}
.vx-report__score {
  display: flex;
  align-items: baseline;
  margin-left: auto;
}
.vx-report__num {
  font-size: 52px;
  font-weight: 600;
  letter-spacing: -0.06em;
  line-height: 0.9;
}
.vx-report__score small {
  font-size: 15px;
  color: var(--mute);
}
.vx-report__verdict {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  font-size: 12px;
  color: var(--mute);
}
.vx-tabs {
  display: flex;
  gap: 2px;
  padding: 0 14px;
  border-bottom: 1px solid var(--line);
  overflow: hidden;
}
.vx-tabs__t {
  position: relative;
  flex: none;
  padding: 13px 10px;
  font-size: 13px;
  color: var(--mute);
  white-space: nowrap;
  transition: color 0.3s;
}
.vx-tabs__t.is-on {
  color: var(--ink);
  font-weight: 600;
}
.vx-tabs__ink {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: -1px;
  height: 2px;
  border-radius: 2px;
  background: var(--sig);
}
.vx-report__body {
  flex: 1;
  min-height: 0;
  padding: 22px;
  overflow: hidden;
}
.vx-rp {
  display: grid;
  gap: 18px;
}
.vx-rp__k {
  display: block;
  margin-bottom: 8px;
  font-family: var(--f-mono);
  font-size: 10.5px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--mute);
}
.vx-rp--summary {
  grid-template-columns: 1fr;
}
.vx-rp__lists {
  display: grid;
  gap: 18px;
}
.vx-rp__lists ul {
  display: grid;
  gap: 6px;
}
.vx-rp__lists li {
  position: relative;
  padding-left: 18px;
  font-size: 14px;
}
.vx-rp__lists li::before {
  position: absolute;
  left: 0;
  font-family: var(--f-mono);
}
.vx-rp__lists li.is-good::before {
  content: '+';
  color: var(--sig);
}
.vx-rp__lists li.is-note::before {
  content: '△';
  font-size: 10px;
  top: 3px;
  color: var(--warn);
}
.vx-radar {
  width: 100%;
  max-width: 300px;
  overflow: visible;
}
.vx-radar__grid {
  fill: none;
  stroke: var(--line-2);
  stroke-width: 0.6;
}
.vx-radar__shape {
  fill: rgba(67, 97, 238, 0.16);
  stroke: var(--sig);
  stroke-width: 1.5;
}
.vx-radar text {
  font-size: 7.5px;
  fill: var(--ink-2);
  font-family: var(--f-sans);
}
.vx-rbar {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 4px 10px;
  margin-bottom: 8px;
  font-size: 13px;
}
.vx-rbar b {
  font-family: var(--f-mono);
  font-weight: 500;
  font-size: 12px;
}
.vx-rbar div,
.vx-rbar__track {
  grid-column: 1 / -1;
  height: 5px;
  border-radius: 5px;
  background: var(--paper-2);
  overflow: hidden;
}
.vx-rbar i,
.vx-rbar__track i {
  display: block;
  height: 100%;
  background: var(--ink);
  transform-origin: left;
}
.vx-crit {
  display: grid;
  gap: 8px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--line);
}
.vx-crit__top {
  display: flex;
  align-items: center;
  gap: 10px;
}
.vx-crit__top b {
  margin-left: auto;
  font-size: 22px;
  letter-spacing: -0.03em;
}
.vx-crit p {
  font-size: 13.5px;
  color: var(--ink-2);
}
.vx-band {
  padding: 2px 8px;
  border-radius: 6px;
  background: var(--sig-soft);
  color: var(--sig-ink);
  font-size: 11px;
  font-weight: 600;
}
.vx-rp--transcript {
  grid-template-columns: 1fr;
}
.vx-player__screen {
  position: relative;
  display: grid;
  place-items: center;
  aspect-ratio: 16 / 9;
  border-radius: 14px;
  background: linear-gradient(135deg, #1c2029, #111827);
  color: var(--night-text);
}
.vx-player__play {
  display: grid;
  place-items: center;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  font-size: 14px;
}
.vx-player__time {
  position: absolute;
  left: 12px;
  bottom: 10px;
  font-size: 11px;
  opacity: 0.7;
}
.vx-player__scrub {
  position: relative;
  height: 4px;
  margin: 12px 0 10px;
  border-radius: 4px;
  background: var(--line);
}
.vx-player__fill {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 21%;
  border-radius: inherit;
  background: var(--sig);
}
.vx-player__scrub b {
  position: absolute;
  top: -4px;
  width: 2px;
  height: 12px;
  border-radius: 2px;
  background: var(--warn);
}
.vx-turns {
  display: grid;
  gap: 8px;
}
.vx-turns li {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 2px 12px;
  padding: 10px 12px;
  border-radius: 12px;
  font-size: 13.5px;
  transition: background-color 0.3s;
}
.vx-turns li.is-active {
  background: var(--sig-soft);
  box-shadow: inset 2px 0 0 var(--sig);
}
.vx-turns__at {
  grid-row: span 2;
  color: var(--sig-ink);
}
.vx-turns__who {
  font-size: 11px;
  font-weight: 600;
  color: var(--mute);
}
.vx-turns p {
  grid-column: 2;
}
.vx-turns__score {
  grid-column: 3;
  grid-row: 1 / span 2;
  align-self: center;
  font-family: var(--f-mono);
  font-size: 12px;
  color: var(--sig-ink);
}
.vx-rp--coding {
  grid-template-columns: 1fr;
}
.vx-code--mini {
  margin-top: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #0d1016;
  font-size: 11.5px;
  line-height: 1.6;
}
.vx-quote {
  font-family: var(--f-serif);
  font-style: italic;
  font-size: 20px;
  line-height: 1.25;
}
.vx-rp--proctor {
  grid-template-columns: 1fr;
}
.vx-rp__verdict {
  display: grid;
  gap: 14px;
  justify-items: start;
}
.vx-tiles {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  width: 100%;
}
.vx-tiles div {
  display: flex;
  flex-direction: column;
  padding: 12px;
  border-radius: 12px;
  box-shadow: inset 0 0 0 1px var(--line);
}
.vx-tiles strong {
  font-size: 24px;
  letter-spacing: -0.03em;
}
.vx-tiles span,
.vx-signals span {
  font-size: 12px;
  color: var(--mute);
}
.vx-signals {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}
.vx-signals li {
  display: flex;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: 10px;
  background: var(--paper);
}
.vx-signals b {
  font-family: var(--f-mono);
  font-weight: 500;
}
.vx-rp--rec {
  max-width: 640px;
}
.vx-rec-big {
  font-size: clamp(2rem, 4vw, 3.6rem);
  letter-spacing: -0.045em;
  line-height: 1;
  color: var(--sig-ink);
}
.vx-rp--rec p {
  color: var(--ink-2);
}
.vx-export {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.vx-export .vx-rp__k {
  margin: 0 6px 0 0;
}
.vx-export span:not(.vx-rp__k) {
  padding: 7px 12px;
  border-radius: 9px;
  box-shadow: inset 0 0 0 1px var(--line-2);
  font-size: 13px;
}
@media (min-width: 900px) {
  .vx-rp--summary {
    grid-template-columns: 0.9fr 1.1fr;
    align-items: center;
  }
  .vx-rp--summary .vx-rp__lists {
    grid-template-columns: 1fr 1fr;
  }
  .vx-rp--summary .vx-rp__lists > div:last-child {
    grid-column: 1 / -1;
  }
  .vx-rp:not(.vx-rp--summary):not(.vx-rp--rec):not(.vx-rp--transcript):not(.vx-rp--coding):not(
      .vx-rp--proctor
    ) {
    grid-template-columns: 1fr 1fr;
    gap: 18px 32px;
  }
  .vx-rp--transcript,
  .vx-rp--coding,
  .vx-rp--proctor {
    grid-template-columns: 1fr 1fr;
    gap: 28px;
  }
}
@media (max-width: 640px) {
  .vx-report__head {
    padding: 14px;
  }
  .vx-report__score {
    margin-left: 0;
  }
  .vx-report__body {
    padding: 14px;
  }
  .vx-tabs {
    overflow-x: auto;
    scrollbar-width: none;
  }
}

/* ------------------------------- Sections ------------------------------- */

.vx-section {
  position: relative;
  padding: clamp(96px, 14vh, 160px) var(--gutter);
}
.vx-section__head {
  display: grid;
  gap: 22px;
  max-width: 980px;
  margin-bottom: clamp(40px, 6vw, 72px);
}
.vx-section__head .vx-h2 {
  max-width: 14ch;
}
.vx-chapter--system {
  background: var(--paper-2);
}

/* Command center */
.vx-cmd {
  border-radius: 26px;
  background: var(--card);
  box-shadow:
    inset 0 0 0 1px var(--line),
    0 60px 120px -70px rgba(17, 24, 39, 0.6);
  overflow: hidden;
}
.vx-cmd__top {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid var(--line);
}
.vx-scope {
  display: flex;
  gap: 4px;
  padding: 3px;
  border-radius: 10px;
  background: var(--paper-2);
  font-size: 13px;
}
.vx-scope span {
  padding: 6px 12px;
  border-radius: 8px;
  color: var(--mute);
  white-space: nowrap;
}
.vx-scope span.is-on {
  background: var(--card);
  color: var(--ink);
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(17, 24, 39, 0.12);
}
.vx-cmd__actions {
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 12px;
  color: var(--mute);
}
.vx-cmd__export {
  padding: 6px 10px;
  border-radius: 8px;
  box-shadow: inset 0 0 0 1px var(--line-2);
  color: var(--ink);
}
.vx-cmd__grid {
  display: grid;
  grid-template-columns: 1fr;
}
.vx-cmd__cell {
  padding: 20px;
  border-bottom: 1px solid var(--line);
}
@media (min-width: 960px) {
  .vx-cmd__grid {
    grid-template-columns: 1.6fr 1fr;
  }
  .vx-cmd__cell:nth-child(odd) {
    border-right: 1px solid var(--line);
  }
  .vx-cmd__cell--recent {
    grid-column: 1 / -1;
    border-right: 0 !important;
  }
}
.vx-funnel {
  width: 100%;
  overflow: visible;
}
.vx-funnel__s {
  fill: none;
  stroke-linecap: round;
}
.vx-funnel__s--sched {
  stroke: var(--ink);
  stroke-width: 26;
}
.vx-funnel__s--done {
  stroke: var(--ink);
  stroke-width: 20;
}
.vx-funnel__s--lost {
  stroke: var(--line-2);
  stroke-width: 5;
}
.vx-funnel__s--pass {
  stroke: var(--sig);
  stroke-width: 9;
}
.vx-funnel__s--fail {
  stroke: var(--mute);
  stroke-width: 11;
}
.vx-funnel text,
.vx-life text {
  font-family: var(--f-mono);
  font-size: 9.5px;
  letter-spacing: 0.06em;
  fill: var(--ink-2);
}
.vx-funnel text.is-dim,
.vx-life text.is-dim {
  fill: var(--mute);
}
.vx-funnel text.is-pass,
.vx-life text.is-pass {
  fill: var(--sig-ink);
}
.vx-life text.is-warn {
  fill: var(--warn);
}
.vx-activity {
  width: 100%;
  height: 120px;
  overflow: visible;
}
.vx-activity path {
  fill: none;
  stroke-width: 2;
  vector-effect: non-scaling-stroke;
}
.vx-activity__a {
  stroke: var(--line-2);
}
.vx-activity__b {
  stroke: var(--sig);
}
.vx-donut {
  display: flex;
  align-items: center;
  gap: 22px;
}
.vx-donut svg {
  width: 110px;
  height: 110px;
}
.vx-donut__s {
  fill: none;
  stroke-width: 12;
}
.vx-donut__s--0,
.vx-donut__k--0 {
  stroke: var(--sig);
  background: var(--sig);
}
.vx-donut__s--1,
.vx-donut__k--1 {
  stroke: var(--ink);
  background: var(--ink);
}
.vx-donut__s--2,
.vx-donut__k--2 {
  stroke: var(--line-2);
  background: var(--line-2);
}
.vx-donut ul {
  display: grid;
  gap: 6px;
  font-size: 13px;
}
.vx-donut li {
  display: flex;
  align-items: center;
  gap: 8px;
}
.vx-donut__k {
  width: 10px;
  height: 10px;
  border-radius: 3px;
}
.vx-cal__head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
}
.vx-cal__head .vx-mono {
  color: var(--mute);
  font-weight: 400;
}
.vx-cal__grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  font-size: 12px;
  text-align: center;
}
.vx-cal__grid b {
  padding: 4px 0;
  font-weight: 500;
  color: var(--mute);
  font-size: 10.5px;
}
.vx-cal__grid span {
  position: relative;
  display: grid;
  place-items: center;
  height: 32px;
  border-radius: 8px;
  color: var(--ink-2);
}
.vx-cal__grid span.is-today {
  background: var(--ink);
  color: var(--paper);
}
.vx-cal__grid em {
  position: absolute;
  bottom: 3px;
  display: flex;
  gap: 2px;
}
.vx-cal__grid em i {
  width: 4px;
  height: 4px;
  border-radius: 50%;
}
.vx-cal__grid .is-done {
  background: var(--ink-2);
}
.vx-cal__grid .is-pass {
  background: var(--sig);
}
.vx-cal__grid .is-sched {
  background: var(--mute);
}
.vx-cal__grid .is-slot {
  background: var(--warn);
}
.vx-row {
  display: grid;
  grid-template-columns: 1.1fr 1.2fr auto auto;
  gap: 12px;
  align-items: center;
  padding: 10px 0;
  border-top: 1px solid var(--line);
  font-size: 14px;
}
.vx-row span {
  color: var(--mute);
}
.vx-row__view {
  color: var(--ink) !important;
  font-weight: 500;
}
.vx-status {
  padding: 3px 9px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 600;
  background: var(--paper-2);
}
.vx-status.is-pass {
  background: var(--sig-soft);
  color: var(--sig-ink) !important;
}
.vx-status.is-live {
  color: var(--warn) !important;
}
@media (max-width: 640px) {
  .vx-row {
    grid-template-columns: 1fr auto;
  }
  .vx-row > span:nth-child(2),
  .vx-row__view {
    display: none;
  }
}

/* Scheduling */
.vx-sched {
  display: grid;
  gap: 40px;
  margin-top: clamp(80px, 10vw, 140px);
  align-items: center;
}
.vx-sched__steps {
  display: grid;
  gap: 0;
  margin: 28px 0 20px;
  border-top: 1px solid var(--line-2);
}
.vx-sched__steps li {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 2px 18px;
  padding: 14px 0;
  border-bottom: 1px solid var(--line-2);
}
.vx-sched__steps .vx-mono {
  grid-row: span 2;
  color: var(--mute);
  font-size: 11px;
  padding-top: 3px;
}
.vx-sched__steps strong {
  font-weight: 600;
}
.vx-sched__steps span:last-child {
  font-size: 14px;
  color: var(--mute);
}
.vx-slots {
  padding: 22px;
  border-radius: 22px;
  background: var(--card);
  box-shadow:
    inset 0 0 0 1px var(--line),
    0 40px 80px -60px rgba(17, 24, 39, 0.5);
}
.vx-slots__head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 16px;
}
.vx-tz {
  font-size: 12px;
  color: var(--mute);
}
.vx-tz b {
  color: var(--ink);
  font-weight: 600;
}
.vx-slots__grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.vx-slots__col {
  display: grid;
  gap: 6px;
}
.vx-slots__col b {
  font-size: 12px;
  font-weight: 600;
  margin-bottom: 2px;
}
.vx-slot {
  position: relative;
  padding: 9px 0;
  border-radius: 10px;
  text-align: center;
  font-family: var(--f-mono);
  font-size: 12.5px;
  box-shadow: inset 0 0 0 1px var(--line);
  transition:
    color 0.3s,
    background-color 0.3s;
}
.vx-slot.is-picked {
  color: var(--ink);
  font-weight: 500;
}
.vx-slot.is-locked {
  background: var(--ink);
  color: var(--paper);
}
.vx-slot__ring {
  position: absolute;
  inset: -2px;
  border-radius: 12px;
  box-shadow: 0 0 0 2px var(--sig);
}
.vx-slots__foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  font-size: 13px;
  color: var(--mute);
}
.vx-slots__confirm {
  padding: 8px 14px;
  border-radius: 10px;
  background: var(--paper-2);
  color: var(--mute);
  font-weight: 600;
  transition:
    background-color 0.3s,
    color 0.3s;
}
.vx-slots__confirm.is-on {
  background: var(--sig);
  color: #fff;
}
@media (min-width: 960px) {
  .vx-sched {
    grid-template-columns: 0.9fr 1.1fr;
    gap: 6vw;
  }
}

/* Lifecycle */
.vx-life {
  margin-top: clamp(80px, 10vw, 140px);
}
.vx-life__scroll {
  margin: 32px calc(var(--gutter) * -1) 18px;
  padding: 0 var(--gutter);
  overflow-x: auto;
  scrollbar-width: none;
}
.vx-life__svg {
  display: block;
  width: 100%;
  min-width: 760px;
  overflow: visible;
}
.vx-life path {
  fill: none;
  stroke-linecap: round;
}
.vx-life__main {
  stroke: var(--ink);
  stroke-width: 2;
}
.vx-life__loop,
.vx-life__resched {
  stroke: var(--warn);
  stroke-width: 1.5;
  stroke-dasharray: 5 6;
}
.vx-life__pass {
  stroke: var(--sig);
  stroke-width: 2;
}
.vx-life__fail {
  stroke: var(--mute);
  stroke-width: 2;
}
.vx-life__exp {
  stroke: var(--line-2);
  stroke-width: 1.5;
}
.vx-life__node {
  fill: var(--paper-2);
  stroke: var(--ink);
  stroke-width: 2;
}
.vx-life__node--warn {
  stroke: var(--warn);
}
.vx-life__token {
  fill: var(--sig);
  filter: drop-shadow(0 0 6px var(--sig));
}

/* Connection */
.vx-chapter--connect {
  background: var(--paper);
}
.vx-ats {
  display: grid;
  gap: 28px;
  align-items: center;
}
.vx-ats__host {
  border-radius: 20px;
  background: var(--paper-2);
  box-shadow: inset 0 0 0 1px var(--line-2);
  overflow: hidden;
}
.vx-window__chrome--host {
  background: var(--card);
}
.vx-ats__body {
  display: grid;
  grid-template-columns: 130px 1fr;
  min-height: 260px;
}
.vx-ats__side {
  display: grid;
  align-content: start;
  gap: 4px;
  padding: 16px 12px;
  border-right: 1px solid var(--line);
  font-size: 13px;
  color: var(--mute);
}
.vx-ats__side b {
  margin-bottom: 10px;
  font-family: var(--f-mono);
  font-size: 11px;
  letter-spacing: 0.12em;
  color: var(--ink);
}
.vx-ats__side span {
  padding: 6px 8px;
  border-radius: 8px;
}
.vx-ats__side span.is-on {
  background: var(--card);
  color: var(--ink);
  font-weight: 600;
}
.vx-ats__frame {
  position: relative;
  margin: 18px;
  padding: 34px 18px 18px;
  border-radius: 14px;
  background: var(--card);
  box-shadow:
    0 0 0 1.5px var(--sig),
    0 30px 60px -40px rgba(67, 97, 238, 0.6);
}
.vx-ats__tag {
  position: absolute;
  top: -1px;
  left: 14px;
  padding: 3px 9px;
  border-radius: 0 0 8px 8px;
  background: var(--sig);
  color: #fff;
  font-family: var(--f-mono);
  font-size: 10.5px;
}
.vx-ats__mini {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.vx-ats__mini span {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}
.vx-ats__mini small {
  color: var(--mute);
  font-size: 12px;
}
.vx-ats__mini > b {
  margin-left: auto;
  font-size: 30px;
  letter-spacing: -0.04em;
}
.vx-ats__skeleton {
  display: grid;
  gap: 8px;
  margin-top: 18px;
}
.vx-ats__skeleton i {
  height: 8px;
  border-radius: 8px;
  background: var(--paper-2);
}
.vx-ats__skeleton i:nth-child(2) {
  width: 80%;
}
.vx-ats__skeleton i:nth-child(3) {
  width: 60%;
}
.vx-handshake {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid var(--line);
  background: var(--card);
  font-family: var(--f-mono);
  font-size: 11px;
  color: var(--mute);
}
.vx-handshake i {
  width: 18px;
  height: 1px;
  background: var(--line-2);
}
.vx-handshake .is-ok {
  color: var(--sig-ink);
}
.vx-ats__out {
  display: grid;
  gap: 16px;
}
.vx-pipe {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.vx-pipe li {
  position: relative;
  padding: 10px 16px;
  border-radius: 99px;
  box-shadow: inset 0 0 0 1px var(--line-2);
  font-weight: 600;
  font-size: 14px;
}
.vx-pipe li:not(:last-child)::after {
  content: '→';
  margin-left: 14px;
  color: var(--mute);
}
.vx-pipe li.is-ok {
  background: var(--sig);
  color: #fff;
  box-shadow: none;
}
.vx-payload {
  padding: 18px;
  border-radius: 16px;
  background: var(--night);
  color: #e5e7eb;
  font-size: 12px;
  line-height: 1.7;
  white-space: pre-wrap;
  word-break: break-word;
}
@media (min-width: 960px) {
  .vx-ats {
    grid-template-columns: 1.15fr 0.85fr;
    gap: 4vw;
  }
}
.vx-team {
  display: grid;
  gap: 32px;
  align-items: center;
  margin-top: clamp(80px, 10vw, 140px);
}
.vx-list {
  display: grid;
  margin-top: 24px;
  border-top: 1px solid var(--line-2);
}
.vx-list li {
  padding: 13px 0;
  border-bottom: 1px solid var(--line-2);
  font-size: 15px;
  color: var(--ink-2);
}
.vx-team__svg {
  width: 100%;
  max-width: 600px;
  justify-self: center;
  overflow: visible;
}
.vx-team__ring {
  fill: none;
  stroke: var(--line-2);
  stroke-dasharray: 3 5;
}
.vx-team__ring--0 {
  fill: var(--sig-soft);
  stroke: rgba(67, 97, 238, 0.4);
}
.vx-team__edge {
  stroke: var(--ink);
  stroke-width: 1.2;
}
.vx-team__assign {
  stroke: var(--sig);
  stroke-width: 1.2;
  stroke-dasharray: 3 3;
}
.vx-team__node {
  fill: var(--card);
  stroke: var(--ink);
  stroke-width: 2;
}
.vx-team__node.is-big {
  fill: var(--ink);
}
.vx-team__label {
  font-size: 11px;
  font-weight: 600;
  fill: var(--ink);
}
.vx-team__scope {
  font-family: var(--f-mono);
  font-size: 9px;
  fill: var(--sig-ink);
}
.vx-team__job {
  fill: var(--card);
  stroke: var(--sig);
}
.vx-team__jobt {
  font-family: var(--f-mono);
  font-size: 10px;
  fill: var(--sig-ink);
}
@media (min-width: 960px) {
  .vx-team {
    grid-template-columns: 0.8fr 1.2fr;
    gap: 6vw;
  }
}

/* Proof */
.vx-proof {
  background: var(--paper);
  border-top: 1px solid var(--line);
}
.vx-proof__list {
  position: relative;
  border-top: 1px solid var(--line-2);
}
.vx-proof__item {
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 4px 20px;
  align-items: baseline;
  padding: clamp(16px, 2.2vw, 26px) 0;
  border-bottom: 1px solid var(--line-2);
  transition:
    opacity 0.4s,
    color 0.4s;
}
.vx-proof__item.is-dim {
  opacity: 0.28;
}
.vx-proof__n {
  color: var(--mute);
}
.vx-proof__name {
  font-size: clamp(2.2rem, 6.4vw, 6.4rem);
  font-weight: 600;
  letter-spacing: -0.055em;
  line-height: 0.95;
  transition:
    transform 0.6s var(--ease),
    color 0.4s;
}
.vx-proof__item.is-on .vx-proof__name {
  transform: translateX(16px);
  color: var(--sig-ink);
}
.vx-proof__note {
  grid-column: 2;
  font-size: 15px;
  color: var(--mute);
}
.vx-proof__inline {
  grid-column: 2;
  margin-top: 10px;
}
.vx-proof__float {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  width: 300px;
  margin: 20px 0 0 20px;
  pointer-events: none;
}
.vx-prev {
  display: grid;
  gap: 10px;
  padding: 16px;
  border-radius: 16px;
  background: var(--card);
  box-shadow:
    inset 0 0 0 1px var(--line),
    0 30px 60px -30px rgba(17, 24, 39, 0.55);
  font-size: 13px;
}
.vx-prev p b {
  margin-right: 6px;
  font-size: 11px;
  color: var(--mute);
}
.vx-prev p.is-cand {
  color: var(--ink-2);
}
.vx-prev .vx-mono {
  color: var(--sig-ink);
}
.vx-prev--s strong {
  font-size: 54px;
  letter-spacing: -0.06em;
  line-height: 0.9;
}
.vx-prev--s small {
  font-size: 15px;
  color: var(--mute);
  letter-spacing: 0;
}
.vx-prev--c code {
  padding: 8px 10px;
  border-radius: 8px;
  background: var(--night);
  color: var(--sig-bright);
  font-size: 12px;
}
.vx-prev--i ul {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 12px;
  color: var(--mute);
}
.vx-prev--i b {
  color: var(--ink);
  float: right;
}
.vx-prev__screen {
  display: grid;
  place-items: center;
  aspect-ratio: 16 / 8;
  border-radius: 10px;
  background: linear-gradient(135deg, #1c2029, #111827);
  color: var(--night-text);
}
.vx-prev .vx-player__scrub {
  margin: 0;
}
@media (pointer: fine) and (min-width: 960px) {
  .vx-proof__inline {
    display: none;
  }
  .vx-proof__item {
    grid-template-columns: 60px 1fr minmax(0, 0.5fr);
  }
  .vx-proof__note {
    grid-column: 3;
    text-align: right;
  }
}
@media not ((pointer: fine) and (min-width: 960px)) {
  .vx-proof__float {
    display: none;
  }
  .vx-proof__inline .vx-prev {
    max-width: 380px;
    box-shadow: inset 0 0 0 1px var(--line);
  }
}

/* Decision */
.vx-decision {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 140px var(--gutter) 90px;
  background: var(--night);
  color: var(--night-text);
  overflow: hidden;
  isolation: isolate;
}
.vx-decision__orb {
  position: absolute;
  right: -12vw;
  top: 50%;
  width: min(70vw, 900px);
  aspect-ratio: 1;
  translate: 0 -50%;
  z-index: -1;
  opacity: 0.9;
}
.vx-decision__title {
  display: flex;
  flex-direction: column;
  margin: 24px 0 40px;
  font-size: clamp(2.9rem, 8.6vw, 9.6rem);
  font-weight: 600;
  line-height: 0.9;
  letter-spacing: -0.06em;
}
.vx-decision__line {
  display: block;
}
.vx-decision__line.vx-serif {
  letter-spacing: -0.035em;
}
.vx-decision__foot {
  display: grid;
  gap: 26px;
  max-width: 560px;
}
.vx-decision__ctas {
  display: flex;
  flex-wrap: wrap;
  gap: 18px 26px;
  align-items: center;
}
.vx-decision__note {
  font-size: 13px;
  color: var(--night-mute);
}
.vx-footer {
  padding: 40px var(--gutter) 28px;
  background: var(--night);
  color: var(--night-text);
  border-top: 1px solid var(--night-line);
}
.vx-footer__row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 18px;
}
.vx-footer__row--small {
  margin-top: 28px;
  font-size: 13px;
  color: var(--night-mute);
}
.vx-footer__links {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 22px;
  font-size: 14px;
  color: var(--night-mute);
}
.vx-footer__links a:hover {
  color: var(--night-text);
}

/* ---------------------------- Reduced motion ---------------------------- */

@media (prefers-reduced-motion: reduce) {
  .vx *,
  .vx *::before,
  .vx *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.2s !important;
  }
  .vx-dot--live::after {
    display: none;
  }
}

/* ------------------------- Narrow-screen fixes -------------------------- */

.vx-nav__product {
  white-space: nowrap;
}
.vx-meet,
.vx-meet__main,
.vx-meet__top,
.vx-workspace,
.vx-workspace__editor,
.vx-observe,
.vx-report {
  min-width: 0;
}
.vx-life__list {
  display: none;
}
@media (max-width: 760px) {
  .vx-life__scroll {
    display: none;
  }
  .vx-life__list {
    display: grid;
    margin: 28px 0 18px;
    padding-left: 18px;
    border-left: 2px solid var(--ink);
  }
  .vx-life__list li {
    position: relative;
    display: grid;
    gap: 2px;
    padding: 10px 0 10px 14px;
  }
  .vx-life__list li::before {
    content: '';
    position: absolute;
    left: -25px;
    top: 15px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--paper-2);
    box-shadow: inset 0 0 0 2px var(--ink);
  }
  .vx-life__list li.is-branch {
    margin-left: 18px;
    padding-left: 14px;
    border-left: 1px dashed var(--line-2);
  }
  .vx-life__list li.is-branch::before {
    left: -44px;
  }
  .vx-life__list b {
    font-family: var(--f-mono);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.06em;
    text-transform: uppercase;
  }
  .vx-life__list li.is-warn b {
    color: var(--warn);
  }
  .vx-life__list li.is-warn::before {
    box-shadow: inset 0 0 0 2px var(--warn);
  }
  .vx-life__list li.is-pass b {
    color: var(--sig-ink);
  }
  .vx-life__list li.is-pass::before {
    background: var(--sig);
    box-shadow: none;
  }
  .vx-life__list span {
    font-size: 14px;
    color: var(--mute);
  }
  .vx-meet__q,
  .vx-meet__timer {
    display: none;
  }
  .vx-meet__top {
    flex-wrap: wrap;
  }
  .vx-decision__orb {
    opacity: 0.45;
    width: 120vw;
    right: -50vw;
  }
}
@media (max-width: 400px) {
  .vx-nav__product {
    display: none;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/ai-landing/styles.css"],"names":[],"mappings":"AAEA;;;;+EAI+E;;AAE/E;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,qBAAqB;EACrB,uCAAuC;EACvC,kFAAkF;EAClF,uDAAuD;EACvD,4EAA4E;EAC5E,gCAAgC;EAChC,qCAAqC;;EAErC,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;qEACqE;AACrE;EACE,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,yDAAuT;AACzT;;AAEA,UAAU;AACV;;EAEE,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;;AAEA,6EAA6E;;AAE7E;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;AACA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,6EAA6E;;AAE7E;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB,sCAAsC;AACxC;AACA;;EAEE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,yCAAyC;AAC3C;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,gFAAgF;EAChF,4CAA4C;AAC9C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;AACZ;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,mDAAmD;AACrD;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA,6EAA6E;;AAE7E;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B;;;;;cAKY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;EACzB,yCAAyC;EACzC,iDAAiD;EACjD,mDAAmD;AACrD;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB;;yBAEuB;AACzB;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA,wEAAwE;AACxE;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,wBAAwB;EACxB,sCAAsC;AACxC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,OAAO;EACP,uBAAuB;AACzB;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,UAAU;EACV,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,kCAAkC;AACpC;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA,6EAA6E;;AAE7E;EACE,kBAAkB;AACpB;AACA;EACE,wBAAgB;EAAhB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;;AAEA,6EAA6E;;AAE7E;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,uDAAuD;EACvD,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,OAAO;EACP,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB;;2CAEyC;EACzC,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,QAAQ;EACR,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC;;4CAE0C;EAC1C,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,QAAQ;EACR,eAAe;AACjB;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,oCAAoC;AACtC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,SAAS;EACT,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB;;4CAE0C;AAC5C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,8CAA8C;EAC9C,sDAAsD;EACtD,iCAAiC;AACnC;AACA;EACE,QAAQ;AACV;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,qDAAqD;EACvD;EACA;IACE,8CAA8C;EAChD;AACF;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,OAAO;EACT;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA,6EAA6E;;AAE7E;EACE,wBAAwB;EACxB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,QAAQ;EACR;;cAEY;AACd;AACA;EACE,8BAA8B;EAC9B,iDAAiD;AACnD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;AACrC;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,0DAA0D;AAC5D;AACA;EACE,kCAAkC;EAClC,iBAAiB;AACnB;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE,sBAAsB;AACxB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,2CAA2C;EAC3C;;;kBAGgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE;IACE,wDAAwD;EAC1D;EACA;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,mBAAmB;EACrB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA,8EAA8E;;AAE9E;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB;;4CAE0C;EAC1C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC;;cAEY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yEAAyE;EACzE,mDAAmD;AACrD;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,wCAAwC;AAC1C;AACA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,sFAAsF;EACtF,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,mEAAmE;EACnE,wBAAwB;EACxB,4BAA4B;EAC5B;;;mBAGiB;AACnB;AACA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,QAAQ;EACR,QAAQ;AACV;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,YAAY;EACZ,SAAS;AACX;AACA;EACE;IACE,wDAAwD;IACxD,QAAQ;IACR,iBAAiB;EACnB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,yCAAyC;EAC3C;EACA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;AACF;;AAEA,6EAA6E;;AAE7E;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,wCAAwC;EACxC,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB;;;2CAGyC;AAC3C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,sBAAsB;EACtB,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,sBAAsB;EACtB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE;eACa;EACb,kDAAkD;EAClD,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,aAAa;EACb,QAAQ;EACR,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;AAC1B;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;AACA;EACE,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE;IACE,wCAAwC;IACxC,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA,6EAA6E;;AAE7E;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,0DAA0D;EAC1D,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,+DAA+D;EACjE;EACA;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;EACxB;AACF;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;;AAEA,6EAA6E;;AAE7E;;EAEE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,qBAAqB;EACrB,wBAAwB;EACxB,0EAA0E;EAC1E,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,0DAA0D;EAC1D,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B;;yCAEuC;AACzC;AACA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;AACnC;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE;;4CAE0C;AAC5C;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,wBAAwB;EACxB,kCAA0B;UAA1B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,SAAS;EACT,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,6CAA6C;EAC7C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,QAAQ;EACR,OAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,wBAAwB;EACxB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,sDAAsD;EACxD;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA,6EAA6E;;AAE7E;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,0EAA0E;AAC5E;AACA;EACE,wDAAwD;EACxD,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,wBAAwB;EACxB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,6CAA6C;EAC7C,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV;;gBAEc;AAChB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB;;wCAEsC;EACtC,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,0CAA0C;EAC1C,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B;;wCAEsC;EACtC,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,qCAAqC;EACrC,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,2BAA2B;EAC3B;;8BAE4B;EAC5B,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,wCAAwC;AAC1C;AACA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC;;wCAEsC;EACtC,mCAA2B;UAA3B,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,UAAU;EACV,WAAW;EACX,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,wDAAwD;EAC1D;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,sBAAsB;EACxB;AACF;;AAEA,6EAA6E;;AAE7E;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,0DAA0D;EAC1D,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;2CAEyC;EACzC,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,oFAAoF;EACpF,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,wFAAwF;AAC1F;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,UAAU;EACV,sBAAsB;EACtB,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,6EAA6E;;AAE7E;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB;;4CAE0C;EAC1C,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;AACjB;AACA;;EAEE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,qDAAqD;EACrD,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;AACA;EACE;IACE,kCAAkC;IAClC,mBAAmB;EACrB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,mBAAmB;EACrB;EACA;;;IAGE,8BAA8B;IAC9B,cAAc;EAChB;EACA;;;IAGE,8BAA8B;IAC9B,SAAS;EACX;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA,6EAA6E;;AAE7E;EACE,kBAAkB;EAClB,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,eAAe;AACjB;AACA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,uBAAuB;EACvB;;4CAE0C;EAC1C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,oCAAoC;AACtC;AACA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mBAAmB;IACnB,0BAA0B;EAC5B;AACF;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,0BAA0B;EAC1B,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;;EAEE,iBAAiB;AACnB;AACA;;EAEE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;;EAEE,kBAAkB;EAClB,sBAAsB;AACxB;AACA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,QAAQ;AACV;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,+BAA+B;EACjC;EACA;;IAEE,aAAa;EACf;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,MAAM;EACN,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;2CAEyC;AAC3C;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,uCAAuC;EACvC;;yBAEuB;AACzB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB;;cAEY;AACd;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE;IACE,kCAAkC;IAClC,QAAQ;EACV;AACF;;AAEA,cAAc;AACd;EACE,oCAAoC;AACtC;AACA;EACE,0CAA0C;EAC1C,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,eAAe;AACf;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,yCAAyC;EACzC,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB;;4CAE0C;AAC5C;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iCAAiC;EACjC,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE;IACE,oCAAoC;IACpC,QAAQ;EACV;AACF;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;AACA;EACE;IACE,kCAAkC;IAClC,QAAQ;EACV;AACF;;AAEA,UAAU;AACV;EACE,wBAAwB;EACxB,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,qBAAqB;EACrB,mCAAmC;EACnC,sCAAsC;EACtC;;cAEY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB;;cAEY;AACd;AACA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;4CAE0C;EAC1C,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,qDAAqD;EACrD,wBAAwB;AAC1B;AACA;EACE,SAAS;AACX;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,gDAAgD;EAClD;EACA;IACE,cAAc;IACd,iBAAiB;EACnB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,gBAAgB;IAChB,uCAAuC;EACzC;AACF;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,wBAAwB;EACxB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,wBAAwB;EACxB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;AAEA,6EAA6E;;AAE7E;EACE;;;IAGE,sCAAsC;IACtC,uCAAuC;IACvC,oCAAoC;EACtC;EACA;IACE,aAAa;EACf;AACF;;AAEA,6EAA6E;;AAE7E;EACE,mBAAmB;AACrB;AACA;;;;;;;EAOE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;EACnC;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,sCAAsC;EACxC;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;EACvC;EACA;IACE,WAAW;EACb;EACA;IACE,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;EAC3B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,uCAAuC;EACzC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;;IAEE,aAAa;EACf;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;IACb,YAAY;IACZ,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;500;600;700&family=Instrument+Serif:ital@0;1&family=JetBrains+Mono:wght@400;500&display=swap');\n\n/* ============================================================================\n * Vriti AI Interview landing — scoped to .vx.\n * Warm paper, near-black ink, and green used only as a signal:\n * live, verified, passed, AI-active.\n * ========================================================================== */\n\n.vx {\n  --paper: #ffffff;\n  --paper-2: #f3f4f6;\n  --card: #ffffff;\n  --ink: #111827;\n  --ink-2: #374151;\n  --mute: #6b7280;\n  --line: rgba(17, 24, 39, 0.1);\n  --line-2: rgba(17, 24, 39, 0.18);\n  --sig: #4361ee;\n  --sig-ink: #2e47c9;\n  --sig-soft: rgba(67, 97, 238, 0.12);\n  --sig-bright: #7b93ff;\n  --warn: #c2791a;\n  --night: #0f1117;\n  --night-2: #171a21;\n  --night-3: #1f232b;\n  --night-line: rgba(255, 255, 255, 0.09);\n  --night-text: #f3f4f6;\n  --night-mute: rgba(243, 244, 246, 0.56);\n  --f-sans: 'Inter Tight', 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;\n  --f-serif: 'Instrument Serif', 'Times New Roman', serif;\n  --f-mono: 'JetBrains Mono', ui-monospace, 'SFMono-Regular', Menlo, monospace;\n  --gutter: clamp(16px, 4vw, 64px);\n  --ease: cubic-bezier(0.16, 1, 0.3, 1);\n\n  position: relative;\n  background: var(--paper);\n  color: var(--ink);\n  font-family: var(--f-sans);\n  font-size: 17px;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  overflow-x: clip;\n}\n\n/* Tailwind preflight is off app-wide, so reset inside the scope. :where()\n   keeps these at zero specificity so component classes always win. */\n.vx :where(*, *::before, *::after) {\n  box-sizing: border-box;\n}\n.vx :where(h1, h2, h3, p, ol, ul, pre, figure) {\n  margin: 0;\n  padding: 0;\n}\n.vx :where(ol, ul) {\n  list-style: none;\n}\n.vx :where(a) {\n  color: inherit;\n  text-decoration: none;\n}\n.vx :where(button) {\n  font: inherit;\n  color: inherit;\n  background: none;\n  border: 0;\n  padding: 0;\n  cursor: pointer;\n}\n.vx :where(mark) {\n  background: none;\n  color: inherit;\n}\n.vx :where(code, pre, kbd) {\n  font-family: var(--f-mono);\n}\n.vx :where(img) {\n  display: block;\n}\n.vx :focus-visible {\n  outline: 2px solid var(--sig);\n  outline-offset: 3px;\n  border-radius: 6px;\n}\n\n/* Grain: one fixed, static layer. */\n.vx::before {\n  content: '';\n  position: fixed;\n  inset: 0;\n  z-index: 60;\n  pointer-events: none;\n  opacity: 0.025;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.85' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\");\n}\n\n/* Lenis */\nhtml.lenis,\nhtml.lenis body {\n  height: auto;\n}\n.lenis.lenis-smooth {\n  scroll-behavior: auto !important;\n}\n.lenis.lenis-stopped {\n  overflow: hidden;\n}\n\n.vx-sr {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n.vx-skip {\n  position: fixed;\n  top: 10px;\n  left: 10px;\n  z-index: 100;\n  padding: 10px 16px;\n  background: var(--ink);\n  color: var(--paper) !important;\n  border-radius: 8px;\n  transform: translateY(-150%);\n  transition: transform 0.2s;\n}\n.vx-skip:focus {\n  transform: none;\n}\n.vx-fallback {\n  min-height: 100vh;\n}\n\n/* ------------------------------- Type ----------------------------------- */\n\n.vx-serif {\n  font-family: var(--f-serif);\n  font-style: italic;\n  font-weight: 400;\n  letter-spacing: -0.01em;\n}\n.vx-mono {\n  font-family: var(--f-mono);\n  font-size: 0.78em;\n  letter-spacing: 0.02em;\n}\n.vx-muted {\n  color: var(--mute);\n}\n.vx-sig {\n  color: var(--sig-bright);\n}\n.vx-eyebrow,\n.vx-kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-family: var(--f-mono);\n  font-size: 12px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--mute);\n}\n.vx-kicker--dark {\n  color: var(--night-mute);\n}\n.vx-chapnum {\n  display: inline-grid;\n  place-items: center;\n  min-width: 30px;\n  height: 22px;\n  padding: 0 6px;\n  border: 1px solid currentColor;\n  border-radius: 99px;\n  font-size: 11px;\n  opacity: 0.9;\n}\n.vx-h2 {\n  font-size: clamp(2.4rem, 5.6vw, 5.6rem);\n  line-height: 0.95;\n  letter-spacing: -0.045em;\n  font-weight: 600;\n  text-wrap: balance;\n}\n.vx-h2 .vx-serif {\n  letter-spacing: -0.02em;\n}\n.vx-h2--dark {\n  color: var(--night-text);\n}\n.vx-h3 {\n  font-size: clamp(1.7rem, 3vw, 2.8rem);\n  line-height: 1.02;\n  letter-spacing: -0.035em;\n  font-weight: 600;\n  text-wrap: balance;\n}\n.vx-body {\n  max-width: 46ch;\n  color: var(--ink-2);\n  font-size: clamp(16px, 1.15vw, 18px);\n  line-height: 1.55;\n  text-wrap: pretty;\n}\n.vx-body--dark {\n  color: var(--night-mute);\n}\n.vx-body--sm {\n  font-size: 15px;\n  color: var(--mute);\n}\n\n.vx-split {\n  display: inline;\n}\n.vx-split__word {\n  display: inline-block;\n  overflow: hidden;\n  vertical-align: top;\n  padding-bottom: 0.08em;\n  margin-bottom: -0.08em;\n}\n.vx-split__piece {\n  display: inline-block;\n  transform-origin: 0 100%;\n  will-change: transform;\n}\n\n/* ------------------------------ Controls -------------------------------- */\n\n.vx-magnetic {\n  display: inline-flex;\n}\n.vx-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  height: 46px;\n  padding: 0 20px;\n  border-radius: 99px;\n  background: var(--ink);\n  color: var(--paper) !important;\n  font-weight: 600;\n  font-size: 15px;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  isolation: isolate;\n  transition: transform 0.4s var(--ease);\n}\n.vx-btn::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: var(--sig);\n  transform: translateY(101%);\n  border-radius: inherit;\n  transition: transform 0.5s var(--ease);\n}\n.vx-btn:hover::after,\n.vx-btn:focus-visible::after {\n  transform: none;\n}\n.vx-btn__arrow {\n  display: inline-block;\n  transition: transform 0.4s var(--ease);\n}\n.vx-btn:hover .vx-btn__arrow {\n  transform: translateX(4px);\n}\n.vx-btn--lg {\n  height: 58px;\n  padding: 0 28px;\n  font-size: 17px;\n}\n.vx-btn--nav {\n  height: 38px;\n  padding: 0 16px;\n  font-size: 14px;\n}\n.vx-btn--ghost {\n  background: transparent;\n  color: var(--ink) !important;\n  box-shadow: inset 0 0 0 1px var(--line-2);\n}\n.vx-btn--sig {\n  background: var(--sig);\n  color: #fff !important;\n}\n.vx-btn--sig::after {\n  background: var(--sig-ink);\n}\n.vx-link-arrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  padding: 8px 2px;\n  background: linear-gradient(currentColor, currentColor) 0 100% / 0 1px no-repeat;\n  transition: background-size 0.5s var(--ease);\n}\n.vx-link-arrow:hover {\n  background-size: 100% 1px;\n}\n.vx-link-arrow--dark {\n  color: var(--night-text);\n}\n\n.vx-dot {\n  position: relative;\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--mute);\n  flex: none;\n}\n.vx-dot--live,\n.vx-dot--ok {\n  background: var(--sig);\n}\n.vx-dot--live::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  background: inherit;\n  animation: vx-ping 1.8s var(--ease) infinite;\n}\n.vx-dot--idle {\n  background: var(--night-mute);\n}\n@keyframes vx-ping {\n  0% {\n    transform: scale(1);\n    opacity: 0.6;\n  }\n  100% {\n    transform: scale(3);\n    opacity: 0;\n  }\n}\n.vx-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 26px;\n  padding: 0 11px;\n  border-radius: 99px;\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.vx-pill--ok {\n  background: var(--sig-soft);\n  color: var(--sig-ink);\n  box-shadow: inset 0 0 0 1px rgba(67, 97, 238, 0.25);\n}\n.vx-pill--lg {\n  height: 36px;\n  padding: 0 16px;\n  font-size: 15px;\n}\n.vx-ok {\n  color: var(--sig);\n}\n.vx-spark {\n  color: var(--sig);\n}\n\n/* --------------------------------- Nav ---------------------------------- */\n\n.vx-nav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  padding: 14px var(--gutter);\n  transition: padding 0.5s var(--ease);\n}\n.vx-nav__bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  height: 56px;\n  padding: 0 10px 0 12px;\n  border-radius: 18px;\n  border: 1px solid transparent;\n  transition:\n    height 0.5s var(--ease),\n    background-color 0.5s,\n    border-color 0.5s,\n    box-shadow 0.5s,\n    color 0.4s;\n}\n.vx-nav.is-compact {\n  padding-top: 10px;\n}\n.vx-nav.is-compact .vx-nav__bar {\n  height: 50px;\n  background: rgba(255, 255, 255, 0.78);\n  border-color: var(--line);\n  backdrop-filter: blur(14px) saturate(1.4);\n  -webkit-backdrop-filter: blur(14px) saturate(1.4);\n  box-shadow: 0 10px 30px -18px rgba(17, 24, 39, 0.3);\n}\n.vx-nav.is-dark .vx-nav__bar {\n  color: var(--night-text);\n}\n.vx-nav.is-dark.is-compact .vx-nav__bar {\n  background: rgba(23, 26, 33, 0.72);\n  border-color: var(--night-line);\n}\n.vx-nav.is-dark .vx-btn--nav {\n  background: var(--night-text);\n  color: var(--night) !important;\n}\n.vx-nav__brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n}\n.vx-nav__brand img {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n}\n.vx-nav__product {\n  display: inline-flex;\n  align-items: center;\n  height: 26px;\n  padding: 0 10px;\n  border-radius: 99px;\n  box-shadow: inset 0 0 0 1px currentColor;\n  font-size: 13px;\n  opacity: 0.85;\n}\n.vx-nav__links {\n  display: none;\n  gap: 4px;\n}\n.vx-nav__link {\n  position: relative;\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  opacity: 0.72;\n  border-radius: 10px;\n  transition:\n    opacity 0.3s,\n    background-color 0.3s;\n}\n.vx-nav__link:hover {\n  opacity: 1;\n  background: var(--line);\n}\n.vx-nav.is-dark .vx-nav__link:hover {\n  background: var(--night-line);\n}\n/* Active page (e.g. Overview on /overview): a small signal underline. */\n.vx-nav__link.is-active {\n  opacity: 1;\n}\n.vx-nav__active {\n  position: absolute;\n  left: 12px;\n  right: 12px;\n  bottom: 3px;\n  height: 2px;\n  border-radius: 2px;\n  background: var(--sig);\n}\n.vx-nav.is-dark .vx-nav__active {\n  background: var(--sig-bright);\n}\n.vx-menu__link.is-active {\n  color: var(--sig-ink);\n}\n.vx-menu__here {\n  margin-left: auto;\n  align-self: center;\n  font-family: var(--f-mono);\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--sig);\n}\n.vx-nav__actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.vx-nav__login {\n  display: none;\n}\n.vx-nav__menu {\n  display: grid;\n  place-content: center;\n  gap: 5px;\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n}\n.vx-nav__menu span {\n  display: block;\n  width: 18px;\n  height: 1.5px;\n  background: currentColor;\n  transition: transform 0.4s var(--ease);\n}\n.vx-nav.is-open .vx-nav__menu span:first-child {\n  transform: translateY(3.25px) rotate(45deg);\n}\n.vx-nav.is-open .vx-nav__menu span:last-child {\n  transform: translateY(-3.25px) rotate(-45deg);\n}\n.vx-menu {\n  position: fixed;\n  inset: 0;\n  z-index: 45;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 110px var(--gutter) 32px;\n  background: var(--paper);\n}\n.vx-menu nav {\n  display: flex;\n  flex-direction: column;\n}\n.vx-menu__link {\n  display: flex;\n  align-items: baseline;\n  gap: 14px;\n  padding: 14px 0;\n  border-bottom: 1px solid var(--line);\n  font-size: clamp(2rem, 9vw, 3rem);\n  font-weight: 600;\n  letter-spacing: -0.04em;\n}\n.vx-menu__link .vx-mono {\n  font-size: 12px;\n  color: var(--mute);\n}\n.vx-menu__actions {\n  display: flex;\n  gap: 10px;\n}\n.vx-menu__actions .vx-btn {\n  flex: 1;\n  justify-content: center;\n}\n\n@media (min-width: 640px) {\n  .vx-nav__login {\n    display: inline-flex;\n  }\n}\n@media (min-width: 1024px) {\n  .vx-nav__links {\n    display: flex;\n  }\n  .vx-nav__menu {\n    display: none;\n  }\n}\n\n/* Chapter rail */\n.vx-rail {\n  position: fixed;\n  left: 16px;\n  top: 50%;\n  z-index: 40;\n  display: none;\n  align-items: center;\n  gap: 14px;\n  transform: translateY(-50%);\n  color: var(--ink);\n  pointer-events: none;\n  transition: color 0.4s;\n}\n.vx-rail.is-dark {\n  color: var(--night-text);\n}\n.vx-rail ol {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.vx-rail li {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: var(--f-mono);\n  font-size: 10px;\n  opacity: 0.25;\n  transition: opacity 0.4s;\n}\n.vx-rail li::before {\n  content: '';\n  width: 10px;\n  height: 1px;\n  background: currentColor;\n  transition: width 0.5s var(--ease);\n}\n.vx-rail li span {\n  display: none;\n}\n.vx-rail li.is-past {\n  opacity: 0.5;\n}\n.vx-rail li.is-active {\n  opacity: 1;\n}\n.vx-rail li.is-active::before {\n  width: 22px;\n  background: var(--sig);\n}\n\n.vx-rail__label {\n  position: relative;\n  overflow: hidden;\n  height: 16px;\n  width: 1px;\n}\n.vx-rail__label span {\n  position: absolute;\n  left: 0;\n  top: 0;\n  white-space: nowrap;\n  font-family: var(--f-mono);\n  font-size: 10px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  writing-mode: vertical-rl;\n  display: none;\n}\n@media (min-width: 1280px) {\n  .vx-rail {\n    display: flex;\n  }\n}\n\n/* ----------------------------- Story scenes ----------------------------- */\n\n.vx-story {\n  position: relative;\n}\n.vx-story[data-mode='scroll'] .vx-story__stage {\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow: hidden;\n}\n.vx-story:not([data-mode='scroll']) .vx-story__stage {\n  position: relative;\n  padding: 112px 0 72px;\n}\n.vx-chapter {\n  scroll-margin-top: 0;\n}\n\n/* --------------------------------- Hero --------------------------------- */\n\n.vx-hero {\n  position: relative;\n  display: grid;\n  grid-template-columns: 1fr;\n  align-items: center;\n  height: 100%;\n  padding: 0 var(--gutter);\n}\n.vx-story[data-mode='scroll'] .vx-hero {\n  grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);\n  gap: 2vw;\n  padding-top: 70px;\n}\n.vx-hero__copy {\n  position: relative;\n  z-index: 2;\n}\n.vx-hero__title {\n  display: flex;\n  flex-direction: column;\n  margin: 22px 0 28px;\n  font-size: clamp(2.9rem, 7vw, 8.2rem);\n  font-weight: 600;\n  line-height: 0.86;\n  letter-spacing: -0.06em;\n}\n.vx-hero__line {\n  display: block;\n}\n.vx-hero__line.vx-serif {\n  letter-spacing: -0.035em;\n  color: var(--ink-2);\n}\n.vx-hero__lead {\n  max-width: 34ch;\n  font-size: clamp(17px, 1.35vw, 21px);\n  line-height: 1.45;\n  color: var(--ink-2);\n  text-wrap: pretty;\n}\n.vx-hero__ctas {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 18px 26px;\n  margin-top: 34px;\n}\n.vx-hero__stage {\n  position: relative;\n  aspect-ratio: 1;\n  width: min(100%, 82vh);\n  justify-self: center;\n  margin-top: 40px;\n}\n.vx-story[data-mode='scroll'] .vx-hero__stage {\n  margin-top: 0;\n}\n.vx-hero__orb {\n  position: absolute;\n  inset: 6%;\n}\n.vx-orb {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.vx-sat {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 13px;\n  color: var(--ink-2);\n}\n.vx-sat__k {\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--mute);\n}\n.vx-sat__v {\n  font-family: var(--f-mono);\n  font-size: 14px;\n  color: var(--ink);\n}\n.vx-sat--status {\n  top: 3%;\n  left: 50%;\n  transform: translateX(-50%);\n  flex-direction: row;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 14px;\n  border-radius: 99px;\n  background: var(--card);\n  box-shadow:\n    inset 0 0 0 1px var(--line),\n    0 12px 30px -20px rgba(17, 24, 39, 0.4);\n  font-family: var(--f-mono);\n  font-size: 12px;\n  letter-spacing: 0.14em;\n  color: var(--ink);\n  white-space: nowrap;\n}\n.vx-sat--timer {\n  top: 16%;\n  right: 0;\n  text-align: right;\n}\n.vx-sat--transcript {\n  left: -6%;\n  top: 36%;\n  width: 46%;\n  max-width: 270px;\n  padding: 14px 16px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.86);\n  box-shadow:\n    inset 0 0 0 1px var(--line),\n    0 20px 40px -28px rgba(17, 24, 39, 0.45);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n.vx-sat--transcript p {\n  font-family: var(--f-serif);\n  font-style: italic;\n  font-size: clamp(17px, 1.5vw, 22px);\n  line-height: 1.2;\n  color: var(--ink);\n}\n.vx-sat__bars {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n}\n.vx-minibar {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 3px;\n  font-size: 12px;\n}\n.vx-minibar i {\n  display: block;\n  height: 3px;\n  border-radius: 3px;\n  background: var(--sig);\n  transform-origin: left;\n}\n.vx-sat--objective {\n  right: -2%;\n  bottom: 26%;\n  width: 40%;\n  max-width: 220px;\n  text-align: right;\n  align-items: flex-end;\n}\n.vx-sat--objective .vx-sat__v {\n  font-family: var(--f-sans);\n  font-size: 14px;\n  font-weight: 500;\n}\n.vx-coverage {\n  display: flex;\n  gap: 4px;\n  margin-top: 4px;\n}\n.vx-coverage i {\n  width: 22px;\n  height: 3px;\n  border-radius: 3px;\n  background: var(--line-2);\n  transition: background-color 0.5s;\n}\n.vx-coverage i.is-on {\n  background: var(--ink);\n}\n.vx-coverage i.is-now {\n  background: var(--sig);\n}\n.vx-sat--code {\n  left: 4%;\n  bottom: 12%;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 12px;\n  border-radius: 10px;\n  box-shadow: inset 0 0 0 1px var(--line-2);\n  background: rgba(255, 255, 255, 0.7);\n}\n.vx-sat__glyph {\n  color: var(--sig);\n}\n.vx-sat--report {\n  z-index: 2;\n  left: 50%;\n  top: 50%;\n  translate: -50% -50%;\n  align-items: center;\n  gap: 10px;\n  padding: 22px 26px;\n  border-radius: 22px;\n  background: var(--card);\n  box-shadow:\n    inset 0 0 0 1px var(--line),\n    0 30px 60px -30px rgba(17, 24, 39, 0.45);\n}\n.vx-sat__score {\n  font-size: 64px;\n  font-weight: 600;\n  letter-spacing: -0.05em;\n  line-height: 0.9;\n  color: var(--ink);\n}\n.vx-sat__score small {\n  font-size: 18px;\n  color: var(--mute);\n  letter-spacing: 0;\n}\n.vx-wave {\n  position: absolute;\n  left: 18%;\n  right: 18%;\n  bottom: 1%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 40px;\n  --amp: 0.35;\n}\n.vx-wave i {\n  width: 2px;\n  height: 100%;\n  border-radius: 2px;\n  background: var(--ink);\n  opacity: 0.6;\n  transform: scaleY(calc(var(--h) * var(--amp)));\n  animation: vx-wave 1.1s ease-in-out infinite alternate;\n  transition: background-color 0.5s;\n}\n.vx-wave.is-speaking {\n  --amp: 1;\n}\n.vx-wave.is-speaking i {\n  background: var(--sig);\n  opacity: 0.9;\n}\n.vx-wave.is-evaluating {\n  --amp: 0.12;\n}\n.vx-wave.is-ready {\n  --amp: 0.06;\n}\n@keyframes vx-wave {\n  from {\n    transform: scaleY(calc(var(--h) * var(--amp) * 0.25));\n  }\n  to {\n    transform: scaleY(calc(var(--h) * var(--amp)));\n  }\n}\n.vx-hero__foot {\n  position: absolute;\n  left: var(--gutter);\n  right: var(--gutter);\n  bottom: 22px;\n  display: none;\n  justify-content: space-between;\n  font-size: 13px;\n  color: var(--mute);\n}\n.vx-story[data-mode='scroll'] .vx-hero__foot {\n  display: flex;\n}\n\n@media (max-width: 959px) {\n  .vx-hero__stage {\n    width: min(100%, 520px);\n  }\n  .vx-sat--transcript {\n    left: 0;\n  }\n  .vx-sat--objective {\n    right: 0;\n  }\n}\n@media (max-width: 520px) {\n  .vx-sat--transcript p {\n    font-size: 15px;\n  }\n  .vx-sat--objective,\n  .vx-sat--timer {\n    font-size: 12px;\n  }\n  .vx-sat--code {\n    display: none;\n  }\n}\n\n/* --------------------------------- Flow --------------------------------- */\n\n.vx-chapter--flow {\n  background: var(--paper);\n  border-top: 1px solid var(--line);\n}\n.vx-flow {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n  padding: 0 var(--gutter);\n}\n.vx-flow__ticker {\n  position: absolute;\n  left: 0;\n  bottom: 2%;\n  display: flex;\n  gap: 2vw;\n  white-space: nowrap;\n  font-size: clamp(4.5rem, 10vw, 11rem);\n  font-weight: 600;\n  letter-spacing: -0.06em;\n  line-height: 1;\n  color: transparent;\n  -webkit-text-stroke: 1px var(--line-2);\n  pointer-events: none;\n  will-change: transform;\n}\n.vx-flow__ticker span {\n  display: inline-flex;\n  gap: 2vw;\n  transition:\n    -webkit-text-stroke-color 0.5s,\n    color 0.5s;\n}\n.vx-flow__ticker span.is-on {\n  color: rgba(67, 97, 238, 0.07);\n  -webkit-text-stroke-color: rgba(67, 97, 238, 0.4);\n}\n.vx-flow__ticker em {\n  font-style: normal;\n}\n.vx-story:not([data-mode='scroll']) .vx-flow__ticker {\n  display: none;\n}\n.vx-story[data-mode='scroll'] .vx-flow {\n  padding-bottom: 14vh;\n}\n.vx-flow__grid {\n  position: relative;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 40px;\n  align-items: center;\n}\n.vx-flow__copy .vx-h2 {\n  margin: 18px 0 32px;\n  max-width: 11ch;\n}\n.vx-flow__station {\n  min-height: 140px;\n  padding-top: 18px;\n  border-top: 1px solid var(--line-2);\n}\n.vx-flow__num {\n  font-family: var(--f-mono);\n  font-size: 12px;\n  color: var(--sig);\n}\n.vx-flow__station h3 {\n  margin: 6px 0 8px;\n  font-size: clamp(1.6rem, 2.6vw, 2.4rem);\n  font-weight: 600;\n  letter-spacing: -0.03em;\n}\n.vx-flow__station p {\n  color: var(--ink-2);\n  max-width: 36ch;\n}\n.vx-flow__visual {\n  display: grid;\n  place-items: center;\n  min-height: 360px;\n}\n.vx-morph {\n  position: relative;\n  width: 400px;\n  height: 320px;\n  transform: scale(var(--morph-scale, 0.82));\n}\n.vx-atom {\n  position: absolute;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  will-change: transform;\n}\n.vx-atom i {\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n}\n.vx-atom.is-wave i {\n  background: inherit;\n  animation: vx-atomwave 0.9s ease-in-out infinite alternate;\n}\n.vx-atom.is-wave {\n  background: transparent !important;\n  overflow: visible;\n}\n@keyframes vx-atomwave {\n  from {\n    transform: scaleY(0.45);\n  }\n  to {\n    transform: scaleY(1);\n  }\n}\n.vx-atom.is-wave i {\n  background: var(--ink);\n}\n.vx-atom.is-wave:nth-child(5) i,\n.vx-atom.is-wave:nth-child(6) i,\n.vx-atom.is-wave:nth-child(7) i {\n  background: var(--sig);\n}\n.vx-morph__lines {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  fill: none;\n  stroke: var(--line-2);\n  stroke-width: 1.5;\n}\n.vx-morph__score {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  font-size: 84px;\n  font-weight: 600;\n  letter-spacing: -0.06em;\n  line-height: 1;\n}\n.vx-morph__score small {\n  position: absolute;\n  top: 64%;\n  font-size: 15px;\n  letter-spacing: 0;\n  color: var(--mute);\n}\n.vx-flow__rail {\n  margin-top: 36px;\n}\n.vx-flow__track {\n  position: relative;\n  height: 1px;\n  background: var(--line-2);\n}\n.vx-flow__track i {\n  position: absolute;\n  inset: 0;\n  background: var(--sig);\n  transform-origin: left;\n}\n.vx-story:not([data-mode='scroll']) .vx-flow__track {\n  display: none;\n}\n.vx-flow__rail ol {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  margin-top: -5px;\n}\n.vx-flow__rail li {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  font-size: 12px;\n  color: var(--mute);\n  transition: color 0.4s;\n}\n.vx-flow__rail li b {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--paper);\n  box-shadow: inset 0 0 0 1.5px var(--line-2);\n  transition:\n    background-color 0.4s,\n    box-shadow 0.4s,\n    transform 0.4s;\n}\n.vx-flow__rail li.is-past {\n  color: var(--ink);\n}\n.vx-flow__rail li.is-past b {\n  background: var(--ink);\n  box-shadow: none;\n}\n.vx-flow__rail li.is-on b {\n  background: var(--sig);\n  transform: scale(1.4);\n}\n@media (min-width: 960px) {\n  .vx-flow__grid {\n    grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);\n  }\n  .vx-morph {\n    --morph-scale: 1.15;\n  }\n}\n@media (min-width: 1400px) {\n  .vx-morph {\n    --morph-scale: 1.35;\n  }\n}\n@media (max-width: 640px) {\n  .vx-flow__rail li span {\n    display: none;\n  }\n  .vx-flow__visual {\n    min-height: 290px;\n  }\n  .vx-morph {\n    --morph-scale: 0.78;\n  }\n}\n\n/* -------------------------- Split scenes (Job) --------------------------- */\n\n.vx-chapter--job {\n  background: var(--paper);\n}\n.vx-split-scene {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 48px;\n  align-items: center;\n  height: 100%;\n  padding: 0 var(--gutter);\n}\n.vx-split-scene__copy .vx-h2 {\n  margin: 18px 0 22px;\n  max-width: 12ch;\n}\n.vx-modes {\n  display: grid;\n  margin-top: 32px;\n  border-top: 1px solid var(--line);\n}\n.vx-modes li {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 0;\n  border-bottom: 1px solid var(--line);\n  color: var(--mute);\n}\n.vx-modes li.is-on {\n  color: var(--ink);\n}\n.vx-modes li.is-on .vx-modes__title::before {\n  content: '✦ ';\n  color: var(--sig);\n}\n.vx-modes__title {\n  font-weight: 600;\n}\n.vx-modes__note {\n  font-size: 14px;\n}\n.vx-split-scene__visual {\n  position: relative;\n  padding: 86px 3vw 86px 0;\n}\n.vx-window {\n  position: relative;\n  border-radius: 18px;\n  background: var(--card);\n  box-shadow:\n    inset 0 0 0 1px var(--line),\n    0 40px 80px -50px rgba(17, 24, 39, 0.55);\n  overflow: hidden;\n}\n.vx-window__chrome {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: 38px;\n  padding: 0 14px;\n  border-bottom: 1px solid var(--line);\n  font-size: 12px;\n  color: var(--mute);\n}\n.vx-window__chrome i {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--line-2);\n}\n.vx-window__chrome span {\n  margin-left: 10px;\n}\n.vx-stepper {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  padding: 16px 18px;\n  border-bottom: 1px solid var(--line);\n}\n.vx-stepper li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--mute);\n  min-width: 0;\n}\n.vx-stepper li span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.vx-stepper b {\n  display: grid;\n  place-items: center;\n  flex: none;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  font-size: 11px;\n  box-shadow: inset 0 0 0 1px var(--line-2);\n  transition:\n    background-color 0.4s,\n    color 0.4s;\n}\n.vx-stepper li.is-on {\n  color: var(--ink);\n  font-weight: 600;\n}\n.vx-stepper li.is-on b {\n  background: var(--ink);\n  color: var(--paper);\n  box-shadow: none;\n}\n.vx-stepper li.is-done b {\n  background: var(--sig);\n  color: #fff;\n  box-shadow: none;\n}\n.vx-wizard__body {\n  padding: 18px;\n  min-height: 340px;\n}\n.vx-aiprompt {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 8px 12px;\n  align-items: center;\n  padding: 14px;\n  border-radius: 14px;\n  background: linear-gradient(180deg, rgba(67, 97, 238, 0.06), transparent);\n  box-shadow: inset 0 0 0 1px rgba(67, 97, 238, 0.25);\n}\n.vx-aiprompt__label {\n  grid-column: 1 / -1;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--sig-ink);\n}\n.vx-aiprompt__field {\n  min-height: 42px;\n  font-size: 14px;\n  line-height: 1.45;\n}\n.vx-aiprompt__go {\n  align-self: end;\n  padding: 7px 12px;\n  border-radius: 9px;\n  background: var(--ink);\n  color: var(--paper);\n  font-size: 12px;\n  font-weight: 600;\n}\n.vx-aiprompt__go.is-busy {\n  background: var(--sig);\n}\n.vx-typed--caret > span:first-child::after {\n  content: '';\n  display: inline-block;\n  width: 1.5px;\n  height: 1.05em;\n  margin-left: 1px;\n  vertical-align: -0.15em;\n  background: var(--sig);\n  animation: vx-blink 1s steps(1) infinite;\n}\n@keyframes vx-blink {\n  50% {\n    opacity: 0;\n  }\n}\n.vx-jd {\n  position: relative;\n  margin-top: 16px;\n  display: grid;\n  gap: 8px;\n}\n.vx-jd__title {\n  font-weight: 600;\n  font-size: 17px;\n  letter-spacing: -0.02em;\n}\n.vx-jd__line {\n  font-size: 14px;\n  line-height: 1.6;\n  color: var(--ink-2);\n}\n.vx-jd__skeleton {\n  position: absolute;\n  inset: 30px 0 0;\n  background: repeating-linear-gradient(180deg, var(--line) 0 8px, transparent 8px 22px);\n  opacity: 0.7;\n  border-radius: 4px;\n}\n.vx-extract {\n  padding: 0 2px;\n  border-radius: 4px;\n  background-image: linear-gradient(var(--sig-soft), var(--sig-soft));\n  background-size: 0% 100%;\n  background-repeat: no-repeat;\n  transition:\n    background-size 0.7s var(--ease),\n    color 0.4s,\n    box-shadow 0.4s;\n}\n.vx-extract.is-lit {\n  background-size: 100% 100%;\n  color: var(--sig-ink);\n  box-shadow: inset 0 -1.5px 0 var(--sig);\n}\n.vx-prefill__note {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 14px;\n  font-size: 13px;\n  color: var(--sig-ink);\n  font-weight: 600;\n}\n.vx-field {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  margin-bottom: 8px;\n  border-radius: 10px;\n  box-shadow: inset 0 0 0 1px var(--line);\n  font-size: 14px;\n}\n.vx-field span {\n  color: var(--mute);\n}\n.vx-range {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 14px;\n  font-size: 12px;\n  color: var(--mute);\n}\n.vx-range div {\n  position: relative;\n  flex: 1;\n  height: 4px;\n  border-radius: 4px;\n  background: var(--line);\n}\n.vx-range i {\n  position: absolute;\n  left: 30%;\n  width: 15%;\n  top: -2px;\n  height: 8px;\n  border-radius: 8px;\n  background: var(--ink);\n}\n.vx-extracted {\n  pointer-events: none;\n}\n.vx-chip {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 10px 14px;\n  border-radius: 12px;\n  background: var(--ink);\n  color: var(--paper);\n  box-shadow: 0 20px 40px -24px rgba(17, 24, 39, 0.7);\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n.vx-chip__k {\n  font-family: var(--f-mono);\n  font-size: 10px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--sig-bright);\n}\n.vx-chip--0 {\n  top: 8px;\n  left: 4%;\n}\n.vx-chip--1 {\n  top: 26px;\n  right: 0;\n}\n.vx-chip--2 {\n  bottom: 8px;\n  left: 10%;\n}\n.vx-chip--3 {\n  bottom: 22px;\n  right: 6%;\n}\n@media (min-width: 960px) {\n  .vx-split-scene {\n    grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);\n    gap: 6vw;\n    padding-top: 40px;\n  }\n}\n@media (max-width: 640px) {\n  .vx-stepper li span {\n    display: none;\n  }\n  .vx-stepper li.is-on span {\n    display: inline;\n  }\n  .vx-stepper {\n    grid-template-columns: auto auto auto 1fr;\n  }\n  .vx-chip {\n    position: relative;\n    inset: auto !important;\n    display: inline-flex;\n    margin: 8px 8px 0 0;\n  }\n  .vx-split-scene__visual {\n    padding: 0;\n  }\n}\n\n/* ------------------------- Configure surface ---------------------------- */\n\n.vx-chapter--config {\n  background: var(--paper-2);\n}\n.vx-config {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 22px;\n  height: 100%;\n  padding: 0 var(--gutter);\n}\n.vx-story[data-mode='scroll'] .vx-config {\n  padding-top: 60px;\n}\n.vx-config__head .vx-h3 {\n  margin-top: 12px;\n}\n.vx-readout {\n  position: relative;\n  height: clamp(2.4rem, 5.6vw, 5.4rem);\n  overflow: hidden;\n  font-family: var(--f-mono);\n  font-weight: 500;\n  font-size: clamp(1.25rem, 4.6vw, 4.6rem);\n  letter-spacing: -0.04em;\n  line-height: 1.15;\n}\n.vx-readout span {\n  position: absolute;\n  left: 0;\n  top: 0;\n  white-space: nowrap;\n}\n.vx-surface {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 28px;\n  padding: 26px;\n  border-radius: 24px;\n  background: var(--paper);\n  box-shadow:\n    inset 0 0 0 1px var(--line),\n    inset 0 2px 0 rgba(255, 255, 255, 0.7),\n    0 30px 60px -40px rgba(17, 24, 39, 0.4);\n}\n.vx-surface__col {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.vx-surface__col--hw {\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-around;\n}\n.vx-ctl {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.vx-ctl__label {\n  display: block;\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--mute);\n}\n.vx-seg {\n  display: flex;\n  padding: 4px;\n  border-radius: 12px;\n  background: var(--paper-2);\n  box-shadow: inset 0 1px 2px rgba(17, 24, 39, 0.08);\n}\n.vx-seg__opt {\n  position: relative;\n  flex: 1;\n  padding: 9px 8px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--mute);\n  transition: color 0.3s;\n  white-space: nowrap;\n}\n.vx-seg__opt span {\n  position: relative;\n  z-index: 1;\n}\n.vx-seg__opt.is-on {\n  color: var(--paper);\n}\n.vx-seg__thumb {\n  position: absolute;\n  inset: 0;\n  border-radius: 9px;\n  background: var(--ink);\n  box-shadow: 0 6px 14px -8px rgba(17, 24, 39, 0.7);\n}\n.vx-switch {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.vx-switch__track {\n  position: relative;\n  flex: none;\n  width: 46px;\n  height: 26px;\n  border-radius: 99px;\n  background: var(--line-2);\n  transition: background-color 0.4s;\n}\n.vx-switch__track i {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 2px 6px rgba(17, 24, 39, 0.25);\n}\n.vx-switch.is-on .vx-switch__track {\n  background: var(--sig);\n}\n.vx-switch__hint {\n  display: block;\n  font-size: 13px;\n  color: var(--mute);\n  margin-top: 2px;\n}\n.vx-dial {\n  position: relative;\n  display: grid;\n  justify-items: center;\n  gap: 8px;\n}\n.vx-dial svg {\n  width: 132px;\n  height: 132px;\n  transform: rotate(-90deg);\n}\n.vx-dial circle {\n  fill: none;\n  stroke-width: 8;\n}\n.vx-dial__bg {\n  stroke: var(--paper-2);\n}\n.vx-dial__fg {\n  stroke: var(--ink);\n  stroke-linecap: round;\n}\n.vx-dial line {\n  stroke: var(--line-2);\n  stroke-width: 2;\n}\n.vx-dial__v {\n  position: absolute;\n  top: 66px;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: grid;\n  justify-items: center;\n  overflow: hidden;\n  height: 52px;\n}\n.vx-dial__v strong {\n  font-size: 34px;\n  font-weight: 600;\n  letter-spacing: -0.04em;\n  line-height: 1;\n}\n.vx-dial__v span {\n  font-size: 11px;\n  color: var(--mute);\n}\n.vx-fader {\n  display: grid;\n  justify-items: center;\n  gap: 10px;\n}\n.vx-fader__track {\n  position: relative;\n  width: 10px;\n  height: 140px;\n  border-radius: 10px;\n  background: var(--paper-2);\n  box-shadow: inset 0 1px 3px rgba(17, 24, 39, 0.12);\n}\n.vx-fader__fill {\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  background: var(--sig);\n  transform-origin: bottom;\n}\n.vx-fader__pos {\n  position: absolute;\n  inset: 0;\n}\n.vx-fader__thumb {\n  position: absolute;\n  left: 50%;\n  top: 0;\n  translate: -50% -50%;\n  padding: 4px 8px;\n  border-radius: 8px;\n  background: var(--ink);\n  color: var(--paper);\n  font-family: var(--f-mono);\n  font-size: 12px;\n  font-weight: 500;\n  box-shadow: 0 6px 14px -6px rgba(17, 24, 39, 0.6);\n}\n.vx-voice__row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 8px 0 4px;\n  font-size: 14px;\n}\n.vx-voice__play {\n  display: grid;\n  place-items: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: var(--ink);\n  color: var(--paper);\n  font-size: 10px;\n}\n.vx-voice__wave {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  height: 22px;\n  margin-left: auto;\n}\n.vx-voice__wave i {\n  width: 2px;\n  height: 100%;\n  border-radius: 2px;\n  background: var(--sig);\n  animation: vx-atomwave 0.7s ease-in-out infinite alternate;\n}\n.vx-agenda {\n  display: grid;\n  gap: 10px;\n}\n.vx-agenda__head {\n  display: flex;\n  justify-content: space-between;\n}\n.vx-agenda__bar {\n  display: flex;\n  gap: 4px;\n  height: 52px;\n}\n.vx-agenda__blk {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  border-radius: 10px;\n  overflow: hidden;\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 0;\n}\n.vx-agenda__blk em {\n  font-style: normal;\n  white-space: nowrap;\n  position: relative;\n  z-index: 1;\n}\n.vx-agenda__blk.is-voice {\n  background: var(--ink);\n  color: var(--paper);\n}\n.vx-agenda__blk.is-code {\n  background: repeating-linear-gradient(135deg, var(--sig-soft) 0 6px, transparent 6px 12px),\n    var(--card);\n  box-shadow: inset 0 0 0 1px rgba(67, 97, 238, 0.4);\n  color: var(--sig-ink);\n}\n.vx-agenda__branches {\n  position: absolute;\n  right: 10px;\n  top: 8px;\n  bottom: 8px;\n  display: flex;\n  gap: 6px;\n  align-items: flex-end;\n}\n.vx-agenda__branches b {\n  width: 3px;\n  height: 100%;\n  border-radius: 3px;\n  background: var(--sig-bright);\n  transform-origin: bottom;\n}\n.vx-agenda__branches b:nth-child(2) {\n  height: 70%;\n}\n.vx-agenda__branches b:nth-child(3) {\n  height: 45%;\n}\n.vx-agenda__legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 22px;\n  font-size: 13px;\n  color: var(--mute);\n}\n.vx-agenda__legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.vx-agenda__legend i {\n  width: 10px;\n  height: 10px;\n  border-radius: 3px;\n}\n.vx-agenda__legend .is-voice {\n  background: var(--ink);\n}\n.vx-agenda__legend .is-code {\n  background: var(--sig-soft);\n  box-shadow: inset 0 0 0 1px var(--sig);\n}\n.vx-agenda__legend .is-follow {\n  background: var(--sig-bright);\n  width: 3px;\n}\n@media (min-width: 960px) {\n  .vx-surface {\n    grid-template-columns: 1.15fr 0.85fr 1fr;\n    gap: 36px;\n    padding: 30px 34px;\n  }\n}\n\n/* ------------------------------ Blueprint ------------------------------- */\n\n.vx-chapter--blueprint {\n  background: var(--paper);\n}\n.vx-blueprint {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 36px;\n  height: 100%;\n  align-content: center;\n  padding: 0 var(--gutter);\n}\n.vx-story[data-mode='scroll'] .vx-blueprint {\n  padding-top: 70px;\n  grid-template-columns: minmax(0, 0.62fr) minmax(0, 1.38fr);\n  gap: 4vw;\n  align-items: center;\n}\n.vx-blueprint__copy .vx-h2 {\n  margin: 18px 0 26px;\n  font-size: clamp(2.2rem, 4.4vw, 4.6rem);\n}\n.vx-blueprint__caption {\n  min-height: 70px;\n  padding-top: 16px;\n  border-top: 1px solid var(--line-2);\n  color: var(--ink-2);\n}\n.vx-blueprint__caption .vx-mono {\n  color: var(--sig);\n  margin-right: 6px;\n}\n.vx-blueprint__board {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 18px;\n  align-items: start;\n}\n.vx-blueprint__link {\n  display: none;\n}\n@media (min-width: 960px) {\n  .vx-blueprint__board {\n    grid-template-columns: minmax(0, 0.85fr) 40px minmax(0, 1.15fr);\n  }\n  .vx-blueprint__link {\n    display: block;\n    align-self: center;\n    height: 1px;\n    background: var(--line);\n  }\n  .vx-blueprint__link i {\n    display: block;\n    height: 100%;\n    background: var(--sig);\n    transform-origin: left;\n  }\n}\n.vx-criteria,\n.vx-tree {\n  padding: 20px;\n  border-radius: 20px;\n  background: var(--card);\n  box-shadow: inset 0 0 0 1px var(--line);\n  transform-origin: left center;\n}\n.vx-criteria__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n.vx-tag {\n  display: inline-flex;\n  padding: 4px 9px;\n  border-radius: 99px;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n.vx-tag--ai {\n  background: var(--sig-soft);\n  color: var(--sig-ink);\n}\n.vx-tag--edit {\n  background: var(--paper-2);\n  color: var(--ink-2);\n}\n.vx-criteria__list {\n  display: grid;\n  gap: 16px;\n}\n.vx-criteria__row {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n}\n.vx-criteria__name {\n  font-family: var(--f-mono);\n  font-size: 12px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n.vx-criteria__w {\n  position: relative;\n  display: inline-flex;\n  align-items: baseline;\n  overflow: hidden;\n  font-size: 30px;\n  font-weight: 600;\n  letter-spacing: -0.04em;\n  line-height: 1;\n}\n.vx-criteria__w small {\n  font-size: 14px;\n  color: var(--mute);\n}\n.vx-criteria__bar {\n  height: 6px;\n  margin: 8px 0 6px;\n  border-radius: 6px;\n  background: var(--paper-2);\n  overflow: hidden;\n}\n.vx-criteria__bar i {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: var(--ink);\n  transform-origin: left;\n}\n.vx-criteria__list li.is-top .vx-criteria__bar i {\n  background: var(--sig);\n}\n.vx-criteria__ind {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 12px;\n  font-size: 12px;\n  color: var(--mute);\n}\n.vx-tree__list {\n  display: grid;\n  gap: 12px;\n}\n.vx-tree__node {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  background: var(--ink);\n  color: var(--paper);\n}\n.vx-tree__id {\n  font-family: var(--f-mono);\n  font-size: 11px;\n  opacity: 0.6;\n  white-space: nowrap;\n}\n.vx-tree__title {\n  font-weight: 600;\n  font-size: 14px;\n}\n.vx-tree__w {\n  margin-left: auto;\n  font-family: var(--f-mono);\n  font-size: 13px;\n  color: var(--sig-bright);\n}\n.vx-tree__obj > ol {\n  display: grid;\n  gap: 6px;\n  margin: 6px 0 0 18px;\n  padding-left: 14px;\n  border-left: 1px solid var(--line-2);\n}\n.vx-tree__sub {\n  position: relative;\n}\n.vx-tree__sub::before {\n  content: '';\n  position: absolute;\n  left: -14px;\n  top: 17px;\n  width: 12px;\n  height: 1px;\n  background: var(--line-2);\n}\n.vx-tree__subnode {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  padding: 7px 10px;\n  border-radius: 9px;\n  box-shadow: inset 0 0 0 1px var(--line-2);\n  font-size: 13px;\n  font-weight: 500;\n}\n.vx-tree__subnode .vx-tree__id {\n  opacity: 1;\n  color: var(--mute);\n}\n.vx-tree__q {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  overflow: hidden;\n  padding: 0 4px 0 10px;\n  font-size: 13px;\n  color: var(--ink-2);\n}\n.vx-tree__q > * {\n  margin-top: 7px;\n}\n.vx-tree__qmark {\n  flex: none;\n  font-family: var(--f-mono);\n  font-size: 11px;\n  color: var(--sig);\n}\n.vx-tree__eval {\n  flex: none;\n  margin-left: auto;\n  padding: 2px 7px;\n  border-radius: 6px;\n  background: var(--sig-soft);\n  color: var(--sig-ink);\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n  white-space: nowrap;\n}\n.vx-tree__total {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 14px;\n  padding-top: 12px;\n  border-top: 1px dashed var(--line-2);\n  font-size: 13px;\n  color: var(--mute);\n}\n.vx-tree__total strong {\n  font-family: var(--f-mono);\n  font-weight: 500;\n  color: var(--ink);\n}\n@media (max-width: 640px) {\n  .vx-tree__eval {\n    display: none;\n  }\n}\n\n/* ------------------------------ Interview ------------------------------- */\n\n.vx-chapter--interview,\n.vx-chapter--coding {\n  background: var(--night);\n}\n.vx-chapter--interview {\n  background: var(--paper);\n}\n.vx-story:not([data-mode='scroll']).vx-chapter--interview {\n  background: var(--night);\n}\n.vx-room {\n  position: relative;\n  height: 100%;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 28px;\n  align-content: center;\n  padding: 0 var(--gutter);\n  background: radial-gradient(80% 60% at 30% 40%, #182040, var(--night) 70%);\n  color: var(--night-text);\n  overflow: hidden;\n  will-change: transform;\n}\n.vx-story[data-mode='scroll'] .vx-room {\n  grid-template-columns: minmax(0, 0.58fr) minmax(0, 1.42fr);\n  grid-template-rows: 1fr auto;\n  gap: 18px 4vw;\n  padding-top: 84px;\n  padding-bottom: 28px;\n}\n.vx-room__intro {\n  align-self: center;\n}\n.vx-room__intro .vx-h2 {\n  margin: 18px 0 22px;\n  font-size: clamp(2.2rem, 4.4vw, 4.6rem);\n}\n.vx-room__facts {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 22px;\n  font-size: 13px;\n  color: var(--night-mute);\n}\n.vx-story[data-mode='scroll'] .vx-room__facts {\n  grid-column: 1 / -1;\n  border-top: 1px solid var(--night-line);\n  padding-top: 16px;\n}\n.vx-room__facts li::before {\n  content: '— ';\n  color: var(--sig-bright);\n}\n.vx-meet {\n  position: relative;\n  display: grid;\n  grid-template-rows: auto 1fr auto auto;\n  gap: 12px;\n  min-height: 0;\n  padding: 14px;\n  border-radius: 22px;\n  background: var(--night-2);\n  box-shadow:\n    inset 0 0 0 1px var(--night-line),\n    0 50px 100px -40px rgba(0, 0, 0, 0.8);\n}\n.vx-story[data-mode='scroll'] .vx-meet {\n  height: min(72vh, 680px);\n  align-self: center;\n}\n.vx-meet__top {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 12px;\n  color: var(--night-mute);\n}\n.vx-meet__role {\n  display: none;\n}\n.vx-meet__q {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  padding: 6px 12px;\n  border-radius: 99px;\n  background: var(--night-3);\n  color: var(--night-text);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.vx-meet__q .vx-mono {\n  color: var(--sig-bright);\n}\n.vx-meet__meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  margin-left: auto;\n  white-space: nowrap;\n}\n.vx-meet__timer {\n  font-size: 13px;\n  color: var(--night-text);\n}\n.vx-rec {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-family: var(--f-mono);\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  color: #ff6b5e;\n}\n.vx-rec i {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n  animation: vx-blink 1.4s steps(1) infinite;\n}\n.vx-rec--light {\n  color: #d1453b;\n}\n.vx-conn {\n  display: inline-flex;\n  align-items: flex-end;\n  gap: 2px;\n}\n.vx-conn i {\n  width: 3px;\n  border-radius: 1px;\n  background: var(--sig-bright);\n  transition: background-color 0.3s;\n}\n.vx-conn i:nth-child(1) {\n  height: 5px;\n}\n.vx-conn i:nth-child(2) {\n  height: 8px;\n}\n.vx-conn i:nth-child(3) {\n  height: 11px;\n  margin-right: 5px;\n}\n.vx-conn.is-bad i {\n  background: var(--warn);\n}\n.vx-conn.is-bad i:nth-child(n + 2) {\n  background: var(--night-line);\n}\n.vx-meet__main {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n  min-height: 0;\n}\n.vx-tile {\n  position: relative;\n  border-radius: 16px;\n  background: var(--night-3);\n  overflow: hidden;\n  box-shadow: inset 0 0 0 1px var(--night-line);\n}\n.vx-tile--ai {\n  min-height: 260px;\n  transition: box-shadow 0.5s;\n}\n.vx-tile--ai.is-speaking {\n  box-shadow:\n    inset 0 0 0 1px rgba(123, 147, 255, 0.35),\n    0 0 60px -20px rgba(123, 147, 255, 0.35);\n}\n.vx-tile--ai .vx-orb {\n  position: absolute;\n  inset: 8%;\n  width: 84%;\n  height: 84%;\n}\n.vx-tile__label {\n  position: absolute;\n  left: 12px;\n  bottom: 12px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 5px 10px;\n  border-radius: 99px;\n  background: rgba(0, 0, 0, 0.45);\n  font-size: 12px;\n  color: var(--night-text);\n  backdrop-filter: blur(6px);\n}\n.vx-meet__side {\n  display: none;\n  grid-template-rows: auto 1fr;\n  gap: 12px;\n  min-height: 0;\n}\n.vx-tile--cam {\n  aspect-ratio: 4 / 3;\n}\n.vx-cam {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.vx-cam__box {\n  fill: none;\n  stroke: var(--sig-bright);\n  stroke-width: 1.5;\n}\n.vx-chat {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  border-radius: 16px;\n  background: var(--night-3);\n  box-shadow: inset 0 0 0 1px var(--night-line);\n  overflow: hidden;\n}\n.vx-chat__head {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--night-line);\n  font-size: 12px;\n  color: var(--night-mute);\n}\n.vx-chat__list {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  gap: 8px;\n  flex: 1;\n  min-height: 0;\n  padding: 12px;\n  overflow: hidden;\n}\n.vx-bubble {\n  max-width: 88%;\n  padding: 8px 11px;\n  border-radius: 12px;\n  font-size: 12.5px;\n  line-height: 1.4;\n}\n.vx-bubble.is-ai {\n  align-self: flex-start;\n  background: rgba(123, 147, 255, 0.1);\n  color: var(--night-text);\n  border-bottom-left-radius: 4px;\n}\n.vx-bubble.is-cand {\n  align-self: flex-end;\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--night-text);\n  border-bottom-right-radius: 4px;\n}\n.vx-bubble.is-status {\n  align-self: center;\n  background: none;\n  color: var(--warn);\n  font-family: var(--f-mono);\n  font-size: 11px;\n}\n.vx-captions {\n  min-height: 64px;\n}\n.vx-captions__line {\n  font-size: clamp(16px, 1.6vw, 22px);\n  line-height: 1.35;\n  letter-spacing: -0.01em;\n}\n.vx-captions__line.is-ai {\n  color: var(--night-text);\n}\n.vx-captions__line.is-cand {\n  color: rgba(243, 244, 246, 0.8);\n}\n.vx-captions__who {\n  margin-right: 10px;\n  font-family: var(--f-mono);\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--sig-bright);\n}\n.vx-captions__line.is-cand .vx-captions__who {\n  color: var(--night-mute);\n}\n.vx-meet__controls {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n}\n.vx-ctrl {\n  padding: 8px 14px;\n  border-radius: 99px;\n  background: var(--night-3);\n  font-size: 12px;\n  color: var(--night-mute);\n}\n.vx-ctrl--end {\n  background: #c2392f;\n  color: #fff;\n}\n.vx-drop {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  border-radius: inherit;\n  background: rgba(15, 17, 23, 0.62);\n  backdrop-filter: blur(4px);\n}\n.vx-drop__card {\n  display: grid;\n  justify-items: center;\n  gap: 8px;\n  max-width: 280px;\n  padding: 22px 26px;\n  border-radius: 18px;\n  background: var(--night-2);\n  box-shadow: inset 0 0 0 1px var(--night-line);\n  text-align: center;\n  font-size: 13px;\n  color: var(--night-mute);\n}\n.vx-drop__card strong {\n  font-size: 18px;\n  color: var(--night-text);\n}\n.vx-drop__spin {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: 2px solid var(--night-line);\n  border-top-color: var(--warn);\n  animation: vx-spin 0.9s linear infinite;\n}\n@keyframes vx-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@media (min-width: 760px) {\n  .vx-meet__main {\n    grid-template-columns: minmax(0, 1.5fr) minmax(0, 1fr);\n  }\n  .vx-meet__side {\n    display: grid;\n  }\n}\n@media (min-width: 1200px) {\n  .vx-meet__role {\n    display: inline;\n  }\n}\n\n/* -------------------------------- Coding -------------------------------- */\n\n.vx-coding {\n  position: relative;\n  display: grid;\n  gap: 24px;\n  height: 100%;\n  align-content: center;\n  padding: 0 var(--gutter);\n  color: var(--night-text);\n  background: radial-gradient(70% 60% at 80% 60%, #162042, var(--night) 70%);\n}\n.vx-story[data-mode='scroll'] .vx-coding {\n  grid-template-columns: minmax(0, 0.5fr) minmax(0, 1.5fr);\n  grid-template-rows: 1fr auto;\n  gap: 18px 3vw;\n  padding-top: 84px;\n  padding-bottom: 28px;\n}\n.vx-coding__intro {\n  align-self: center;\n}\n.vx-coding__intro .vx-h2 {\n  margin: 18px 0 22px;\n  font-size: clamp(2.2rem, 4.2vw, 4.4rem);\n}\n.vx-coding__langs {\n  font-family: var(--f-mono);\n  font-size: 12px;\n  color: var(--night-mute);\n  letter-spacing: 0.04em;\n}\n.vx-story[data-mode='scroll'] .vx-coding__langs {\n  grid-column: 1 / -1;\n  padding-top: 16px;\n  border-top: 1px solid var(--night-line);\n}\n.vx-workspace {\n  position: relative;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 12px;\n  align-self: center;\n}\n.vx-problem {\n  display: none;\n  flex-direction: column;\n  gap: 12px;\n  padding: 18px;\n  border-radius: 18px;\n  background: var(--night-2);\n  box-shadow: inset 0 0 0 1px var(--night-line);\n  font-size: 13.5px;\n  color: var(--night-mute);\n}\n.vx-problem h3 {\n  font-size: 19px;\n  letter-spacing: -0.02em;\n  color: var(--night-text);\n}\n.vx-problem code {\n  color: var(--sig-bright);\n  font-size: 12.5px;\n}\n.vx-problem__meta b {\n  color: var(--warn);\n  font-weight: 600;\n}\n.vx-problem__io {\n  display: grid;\n  gap: 5px;\n  padding: 12px;\n  border-radius: 10px;\n  background: var(--night-3);\n  font-size: 11px;\n}\n.vx-problem__io code {\n  color: var(--night-text);\n  font-size: 11.5px;\n}\n.vx-problem__hint span {\n  font-weight: 600;\n  color: var(--night-text);\n}\n.vx-problem__hint p {\n  max-height: 0;\n  overflow: hidden;\n  opacity: 0;\n  transition:\n    max-height 0.5s var(--ease),\n    opacity 0.4s;\n}\n.vx-problem__hint.is-open p {\n  max-height: 40px;\n  opacity: 1;\n  margin-top: 4px;\n}\n.vx-workspace__editor {\n  min-width: 0;\n  transform-origin: left center;\n}\n.vx-editor {\n  position: relative;\n  border-radius: 18px;\n  background: #0d1016;\n  box-shadow:\n    inset 0 0 0 1px var(--night-line),\n    0 40px 80px -40px rgba(0, 0, 0, 0.9);\n  overflow: visible;\n  transition: filter 0.6s;\n}\n.vx-editor.is-submitted {\n  filter: saturate(0.6) brightness(0.8);\n}\n.vx-editor__bar {\n  position: relative;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  height: 44px;\n  padding: 0 12px;\n  border-bottom: 1px solid var(--night-line);\n  font-size: 12px;\n  color: var(--night-mute);\n}\n.vx-editor__file {\n  font-family: var(--f-mono);\n}\n.vx-lang {\n  position: relative;\n  padding: 5px 10px;\n  border-radius: 8px;\n  background: var(--night-3);\n  color: var(--night-text);\n}\n.vx-lang__menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  display: grid;\n  width: 150px;\n  padding: 6px;\n  border-radius: 12px;\n  background: var(--night-3);\n  box-shadow:\n    inset 0 0 0 1px var(--night-line),\n    0 20px 40px -10px rgba(0, 0, 0, 0.8);\n  transform-origin: top left;\n}\n.vx-lang__menu li {\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  color: var(--night-mute);\n}\n.vx-lang__menu li.is-on {\n  background: rgba(123, 147, 255, 0.14);\n  color: var(--sig-bright);\n}\n.vx-editor__timer {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: baseline;\n  gap: 4px;\n  color: var(--night-text);\n}\n.vx-editor__timer .vx-mono {\n  font-size: 13px;\n}\n.vx-editor__submit {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 8px;\n  background: var(--sig-bright);\n  color: var(--night);\n  font-weight: 600;\n}\n.vx-editor__submit kbd {\n  font-size: 10px;\n  opacity: 0.6;\n}\n.vx-editor__submit.is-done {\n  background: var(--night-3);\n  color: var(--sig-bright);\n}\n.vx-code {\n  padding: 14px 0;\n  overflow: hidden;\n  font-size: clamp(11px, 0.9vw, 13.5px);\n  line-height: 1.75;\n  color: #e5e7eb;\n}\n.vx-code__ln {\n  display: flex;\n  gap: 14px;\n  padding-right: 14px;\n  opacity: 0;\n  transform: translateX(-6px);\n  transition:\n    opacity 0.25s,\n    transform 0.4s var(--ease);\n  white-space: pre;\n}\n.vx-code__ln.is-on {\n  opacity: 1;\n  transform: none;\n}\n.vx-code__ln.is-caret code::after {\n  content: '';\n  display: inline-block;\n  width: 7px;\n  height: 1.1em;\n  vertical-align: -0.2em;\n  background: var(--sig-bright);\n  animation: vx-blink 1s steps(1) infinite;\n}\n.vx-code__no {\n  flex: none;\n  width: 34px;\n  text-align: right;\n  color: rgba(255, 255, 255, 0.22);\n}\n.vx-code code {\n  font-size: inherit;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.t-kw {\n  color: #9db0ff;\n}\n.t-fn {\n  color: #7ad7ff;\n}\n.t-str {\n  color: #cbd5e1;\n}\n.t-cm {\n  color: #6b7280;\n  font-style: italic;\n}\n.vx-editor__pip {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 12px 14px;\n  font-size: 11px;\n  color: var(--night-mute);\n}\n.vx-review {\n  position: relative;\n  padding: 18px;\n  border-radius: 18px;\n  background: rgba(23, 26, 33, 0.92);\n  box-shadow:\n    inset 0 0 0 1px rgba(123, 147, 255, 0.3),\n    0 40px 80px -30px rgba(0, 0, 0, 0.9);\n  backdrop-filter: blur(10px);\n}\n.vx-review__head {\n  margin-bottom: 12px;\n  font-family: var(--f-mono);\n  font-size: 12px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--sig-bright);\n}\n.vx-review ul {\n  display: grid;\n  gap: 10px;\n}\n.vx-review li {\n  position: relative;\n  padding-left: 18px;\n  font-size: 13.5px;\n  line-height: 1.45;\n  color: var(--night-text);\n}\n.vx-review li::before {\n  position: absolute;\n  left: 0;\n  font-family: var(--f-mono);\n}\n.vx-review li.is-good::before {\n  content: '+';\n  color: var(--sig-bright);\n}\n.vx-review li.is-note::before {\n  content: '?';\n  color: var(--warn);\n}\n.vx-review__follow {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  margin-top: 16px;\n  padding: 12px;\n  border-radius: 14px;\n  background: rgba(123, 147, 255, 0.08);\n}\n.vx-review__orb {\n  flex: none;\n  width: 56px;\n  height: 56px;\n}\n.vx-review__who {\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--sig-bright);\n}\n.vx-review__follow p {\n  margin-top: 2px;\n  font-family: var(--f-serif);\n  font-style: italic;\n  font-size: 19px;\n  line-height: 1.2;\n}\n@media (min-width: 960px) {\n  .vx-workspace {\n    grid-template-columns: minmax(0, 0.6fr) minmax(0, 1.4fr);\n  }\n  .vx-problem {\n    display: flex;\n  }\n  .vx-review {\n    position: absolute;\n    right: 0;\n    top: 6%;\n    width: min(48%, 420px);\n  }\n}\n\n/* -------------------------------- Context ------------------------------- */\n\n.vx-chapter--context {\n  background: var(--paper);\n}\n.vx-context {\n  display: grid;\n  gap: 36px;\n  height: 100%;\n  align-content: center;\n  padding: 0 var(--gutter);\n}\n.vx-story[data-mode='scroll'] .vx-context {\n  grid-template-columns: minmax(0, 0.62fr) minmax(0, 1.38fr);\n  gap: 4vw;\n  align-items: center;\n  padding-top: 60px;\n}\n.vx-context__copy .vx-h2 {\n  margin: 18px 0 22px;\n  font-size: clamp(2.2rem, 4.4vw, 4.6rem);\n}\n.vx-observe {\n  position: relative;\n  min-height: 420px;\n}\n.vx-observe__timeline {\n  padding: 20px;\n  border-radius: 22px;\n  background: var(--card);\n  box-shadow:\n    inset 0 0 0 1px var(--line),\n    0 40px 80px -60px rgba(17, 24, 39, 0.5);\n  transform-origin: 50% 50%;\n}\n.vx-observe__rec {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--line);\n  font-size: 13px;\n}\n.vx-observe__speed {\n  margin-left: auto;\n  font-size: 12px;\n  color: var(--mute);\n}\n.vx-observe__qs {\n  position: relative;\n  height: 28px;\n  margin: 10px 0 2px calc(var(--label-w, 150px));\n}\n.vx-observe__qs span {\n  position: absolute;\n  top: 6px;\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n  color: var(--mute);\n  translate: -50% 0;\n}\n.vx-observe__tracks {\n  position: relative;\n  display: grid;\n  gap: 6px;\n  --label-w: 150px;\n}\n.vx-track {\n  display: grid;\n  grid-template-columns: var(--label-w, 150px) 1fr;\n  align-items: center;\n  min-height: 40px;\n}\n.vx-track__label {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.2;\n}\n.vx-track__label b {\n  font-family: var(--f-mono);\n  font-size: 11.5px;\n  font-weight: 500;\n  letter-spacing: 0.1em;\n}\n.vx-track__label small {\n  font-size: 11.5px;\n  color: var(--mute);\n}\n.vx-track__lane {\n  position: relative;\n  height: 24px;\n  border-radius: 6px;\n  background: repeating-linear-gradient(90deg, var(--line) 0 1px, transparent 1px 10%);\n  transform-origin: left;\n  container-type: inline-size;\n}\n.vx-track__seg {\n  position: absolute;\n  top: 8px;\n  height: 8px;\n  border-radius: 8px;\n  background: var(--ink);\n  opacity: calc(1 - var(--k, 0));\n}\n.vx-track__mark {\n  position: absolute;\n  left: 0;\n  top: 3px;\n  width: 3px;\n  height: 18px;\n  border-radius: 3px;\n  background: var(--warn);\n  transform: translateX(calc((var(--x) * 1cqw) * (1 - var(--k, 0)) + 50cqw * var(--k, 0)));\n}\n.vx-observe__playlane {\n  position: absolute;\n  top: -6px;\n  bottom: -6px;\n  left: var(--label-w, 150px);\n  right: 0;\n  container-type: inline-size;\n  pointer-events: none;\n}\n.vx-observe__playhead {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 2px;\n  background: var(--sig);\n  box-shadow: 0 0 12px var(--sig);\n}\n.vx-verdict {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 18px;\n  text-align: center;\n  pointer-events: none;\n}\n.vx-verdict__word {\n  font-size: clamp(3.6rem, 9vw, 9rem);\n  font-weight: 600;\n  letter-spacing: -0.06em;\n  line-height: 0.85;\n  text-transform: uppercase;\n}\n.vx-verdict__counts {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px 26px;\n  margin-top: 6px;\n}\n.vx-verdict__counts li {\n  display: flex;\n  flex-direction: column;\n  font-size: 12px;\n  color: var(--mute);\n}\n.vx-verdict__counts strong {\n  font-size: 26px;\n  font-weight: 600;\n  letter-spacing: -0.03em;\n  color: var(--ink);\n}\n.vx-verdict__note {\n  max-width: 44ch;\n  font-size: 13px;\n  color: var(--mute);\n}\n@media (max-width: 640px) {\n  .vx-observe__tracks {\n    --label-w: 96px;\n  }\n  .vx-observe__qs {\n    margin-left: 96px;\n  }\n  .vx-track__label small,\n  .vx-observe__speed {\n    display: none;\n  }\n  .vx-observe {\n    min-height: 470px;\n  }\n}\n\n/* ------------------------------- Evidence ------------------------------- */\n\n.vx-chapter--evidence {\n  background: var(--paper);\n}\n.vx-evidence {\n  position: relative;\n  height: 100%;\n  padding: 0 var(--gutter);\n}\n.vx-story:not([data-mode='scroll']) .vx-evidence {\n  display: grid;\n  gap: 24px;\n}\n.vx-evidence__intro {\n  position: absolute;\n  left: var(--gutter);\n  top: 92px;\n  z-index: 2;\n}\n.vx-evidence__intro .vx-h2 {\n  margin-top: 14px;\n  max-width: 13ch;\n  font-size: clamp(2rem, 4vw, 4rem);\n}\n.vx-story:not([data-mode='scroll']) .vx-evidence__intro {\n  position: relative;\n  left: auto;\n  top: auto;\n}\n.vx-evidence__field {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n.vx-story:not([data-mode='scroll']) .vx-evidence__field {\n  display: none;\n}\n.vx-particles {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n.vx-bigscore {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  font-size: min(42vw, 78vh);\n  font-weight: 600;\n  letter-spacing: -0.07em;\n  line-height: 1;\n  color: var(--ink);\n}\n.vx-bigscore small {\n  position: absolute;\n  right: 18%;\n  bottom: 22%;\n  font-size: 3vw;\n  letter-spacing: 0;\n  color: var(--mute);\n}\n.vx-report {\n  position: absolute;\n  left: var(--gutter);\n  right: var(--gutter);\n  top: 84px;\n  bottom: 28px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 24px;\n  background: var(--card);\n  box-shadow:\n    inset 0 0 0 1px var(--line),\n    0 60px 120px -60px rgba(17, 24, 39, 0.6);\n  overflow: hidden;\n  transform-origin: 50% 100%;\n}\n.vx-story:not([data-mode='scroll']) .vx-report {\n  position: relative;\n  inset: auto;\n}\n.vx-report__head {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 14px 18px;\n  padding: 18px 22px;\n  border-bottom: 1px solid var(--line);\n}\n.vx-avatar {\n  display: grid;\n  place-items: center;\n  flex: none;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: var(--ink);\n  color: var(--paper);\n  font-weight: 600;\n  font-size: 14px;\n}\n.vx-avatar--sm {\n  width: 32px;\n  height: 32px;\n  font-size: 12px;\n}\n.vx-report__who {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n.vx-report__who strong {\n  font-size: 17px;\n  letter-spacing: -0.02em;\n}\n.vx-report__who span {\n  font-size: 13px;\n  color: var(--mute);\n}\n.vx-sample {\n  padding: 3px 8px;\n  border-radius: 6px;\n  background: var(--paper-2);\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--mute);\n}\n.vx-report__score {\n  display: flex;\n  align-items: baseline;\n  margin-left: auto;\n}\n.vx-report__num {\n  font-size: 52px;\n  font-weight: 600;\n  letter-spacing: -0.06em;\n  line-height: 0.9;\n}\n.vx-report__score small {\n  font-size: 15px;\n  color: var(--mute);\n}\n.vx-report__verdict {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  font-size: 12px;\n  color: var(--mute);\n}\n.vx-tabs {\n  display: flex;\n  gap: 2px;\n  padding: 0 14px;\n  border-bottom: 1px solid var(--line);\n  overflow: hidden;\n}\n.vx-tabs__t {\n  position: relative;\n  flex: none;\n  padding: 13px 10px;\n  font-size: 13px;\n  color: var(--mute);\n  white-space: nowrap;\n  transition: color 0.3s;\n}\n.vx-tabs__t.is-on {\n  color: var(--ink);\n  font-weight: 600;\n}\n.vx-tabs__ink {\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: -1px;\n  height: 2px;\n  border-radius: 2px;\n  background: var(--sig);\n}\n.vx-report__body {\n  flex: 1;\n  min-height: 0;\n  padding: 22px;\n  overflow: hidden;\n}\n.vx-rp {\n  display: grid;\n  gap: 18px;\n}\n.vx-rp__k {\n  display: block;\n  margin-bottom: 8px;\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--mute);\n}\n.vx-rp--summary {\n  grid-template-columns: 1fr;\n}\n.vx-rp__lists {\n  display: grid;\n  gap: 18px;\n}\n.vx-rp__lists ul {\n  display: grid;\n  gap: 6px;\n}\n.vx-rp__lists li {\n  position: relative;\n  padding-left: 18px;\n  font-size: 14px;\n}\n.vx-rp__lists li::before {\n  position: absolute;\n  left: 0;\n  font-family: var(--f-mono);\n}\n.vx-rp__lists li.is-good::before {\n  content: '+';\n  color: var(--sig);\n}\n.vx-rp__lists li.is-note::before {\n  content: '△';\n  font-size: 10px;\n  top: 3px;\n  color: var(--warn);\n}\n.vx-radar {\n  width: 100%;\n  max-width: 300px;\n  overflow: visible;\n}\n.vx-radar__grid {\n  fill: none;\n  stroke: var(--line-2);\n  stroke-width: 0.6;\n}\n.vx-radar__shape {\n  fill: rgba(67, 97, 238, 0.16);\n  stroke: var(--sig);\n  stroke-width: 1.5;\n}\n.vx-radar text {\n  font-size: 7.5px;\n  fill: var(--ink-2);\n  font-family: var(--f-sans);\n}\n.vx-rbar {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 4px 10px;\n  margin-bottom: 8px;\n  font-size: 13px;\n}\n.vx-rbar b {\n  font-family: var(--f-mono);\n  font-weight: 500;\n  font-size: 12px;\n}\n.vx-rbar div,\n.vx-rbar__track {\n  grid-column: 1 / -1;\n  height: 5px;\n  border-radius: 5px;\n  background: var(--paper-2);\n  overflow: hidden;\n}\n.vx-rbar i,\n.vx-rbar__track i {\n  display: block;\n  height: 100%;\n  background: var(--ink);\n  transform-origin: left;\n}\n.vx-crit {\n  display: grid;\n  gap: 8px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--line);\n}\n.vx-crit__top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.vx-crit__top b {\n  margin-left: auto;\n  font-size: 22px;\n  letter-spacing: -0.03em;\n}\n.vx-crit p {\n  font-size: 13.5px;\n  color: var(--ink-2);\n}\n.vx-band {\n  padding: 2px 8px;\n  border-radius: 6px;\n  background: var(--sig-soft);\n  color: var(--sig-ink);\n  font-size: 11px;\n  font-weight: 600;\n}\n.vx-rp--transcript {\n  grid-template-columns: 1fr;\n}\n.vx-player__screen {\n  position: relative;\n  display: grid;\n  place-items: center;\n  aspect-ratio: 16 / 9;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #1c2029, #111827);\n  color: var(--night-text);\n}\n.vx-player__play {\n  display: grid;\n  place-items: center;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.12);\n  font-size: 14px;\n}\n.vx-player__time {\n  position: absolute;\n  left: 12px;\n  bottom: 10px;\n  font-size: 11px;\n  opacity: 0.7;\n}\n.vx-player__scrub {\n  position: relative;\n  height: 4px;\n  margin: 12px 0 10px;\n  border-radius: 4px;\n  background: var(--line);\n}\n.vx-player__fill {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 21%;\n  border-radius: inherit;\n  background: var(--sig);\n}\n.vx-player__scrub b {\n  position: absolute;\n  top: -4px;\n  width: 2px;\n  height: 12px;\n  border-radius: 2px;\n  background: var(--warn);\n}\n.vx-turns {\n  display: grid;\n  gap: 8px;\n}\n.vx-turns li {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 2px 12px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  font-size: 13.5px;\n  transition: background-color 0.3s;\n}\n.vx-turns li.is-active {\n  background: var(--sig-soft);\n  box-shadow: inset 2px 0 0 var(--sig);\n}\n.vx-turns__at {\n  grid-row: span 2;\n  color: var(--sig-ink);\n}\n.vx-turns__who {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--mute);\n}\n.vx-turns p {\n  grid-column: 2;\n}\n.vx-turns__score {\n  grid-column: 3;\n  grid-row: 1 / span 2;\n  align-self: center;\n  font-family: var(--f-mono);\n  font-size: 12px;\n  color: var(--sig-ink);\n}\n.vx-rp--coding {\n  grid-template-columns: 1fr;\n}\n.vx-code--mini {\n  margin-top: 12px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: #0d1016;\n  font-size: 11.5px;\n  line-height: 1.6;\n}\n.vx-quote {\n  font-family: var(--f-serif);\n  font-style: italic;\n  font-size: 20px;\n  line-height: 1.25;\n}\n.vx-rp--proctor {\n  grid-template-columns: 1fr;\n}\n.vx-rp__verdict {\n  display: grid;\n  gap: 14px;\n  justify-items: start;\n}\n.vx-tiles {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  width: 100%;\n}\n.vx-tiles div {\n  display: flex;\n  flex-direction: column;\n  padding: 12px;\n  border-radius: 12px;\n  box-shadow: inset 0 0 0 1px var(--line);\n}\n.vx-tiles strong {\n  font-size: 24px;\n  letter-spacing: -0.03em;\n}\n.vx-tiles span,\n.vx-signals span {\n  font-size: 12px;\n  color: var(--mute);\n}\n.vx-signals {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 8px;\n}\n.vx-signals li {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: var(--paper);\n}\n.vx-signals b {\n  font-family: var(--f-mono);\n  font-weight: 500;\n}\n.vx-rp--rec {\n  max-width: 640px;\n}\n.vx-rec-big {\n  font-size: clamp(2rem, 4vw, 3.6rem);\n  letter-spacing: -0.045em;\n  line-height: 1;\n  color: var(--sig-ink);\n}\n.vx-rp--rec p {\n  color: var(--ink-2);\n}\n.vx-export {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n.vx-export .vx-rp__k {\n  margin: 0 6px 0 0;\n}\n.vx-export span:not(.vx-rp__k) {\n  padding: 7px 12px;\n  border-radius: 9px;\n  box-shadow: inset 0 0 0 1px var(--line-2);\n  font-size: 13px;\n}\n@media (min-width: 900px) {\n  .vx-rp--summary {\n    grid-template-columns: 0.9fr 1.1fr;\n    align-items: center;\n  }\n  .vx-rp--summary .vx-rp__lists {\n    grid-template-columns: 1fr 1fr;\n  }\n  .vx-rp--summary .vx-rp__lists > div:last-child {\n    grid-column: 1 / -1;\n  }\n  .vx-rp:not(.vx-rp--summary):not(.vx-rp--rec):not(.vx-rp--transcript):not(.vx-rp--coding):not(\n      .vx-rp--proctor\n    ) {\n    grid-template-columns: 1fr 1fr;\n    gap: 18px 32px;\n  }\n  .vx-rp--transcript,\n  .vx-rp--coding,\n  .vx-rp--proctor {\n    grid-template-columns: 1fr 1fr;\n    gap: 28px;\n  }\n}\n@media (max-width: 640px) {\n  .vx-report__head {\n    padding: 14px;\n  }\n  .vx-report__score {\n    margin-left: 0;\n  }\n  .vx-report__body {\n    padding: 14px;\n  }\n  .vx-tabs {\n    overflow-x: auto;\n    scrollbar-width: none;\n  }\n}\n\n/* ------------------------------- Sections ------------------------------- */\n\n.vx-section {\n  position: relative;\n  padding: clamp(96px, 14vh, 160px) var(--gutter);\n}\n.vx-section__head {\n  display: grid;\n  gap: 22px;\n  max-width: 980px;\n  margin-bottom: clamp(40px, 6vw, 72px);\n}\n.vx-section__head .vx-h2 {\n  max-width: 14ch;\n}\n.vx-chapter--system {\n  background: var(--paper-2);\n}\n\n/* Command center */\n.vx-cmd {\n  border-radius: 26px;\n  background: var(--card);\n  box-shadow:\n    inset 0 0 0 1px var(--line),\n    0 60px 120px -70px rgba(17, 24, 39, 0.6);\n  overflow: hidden;\n}\n.vx-cmd__top {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--line);\n}\n.vx-scope {\n  display: flex;\n  gap: 4px;\n  padding: 3px;\n  border-radius: 10px;\n  background: var(--paper-2);\n  font-size: 13px;\n}\n.vx-scope span {\n  padding: 6px 12px;\n  border-radius: 8px;\n  color: var(--mute);\n  white-space: nowrap;\n}\n.vx-scope span.is-on {\n  background: var(--card);\n  color: var(--ink);\n  font-weight: 600;\n  box-shadow: 0 1px 3px rgba(17, 24, 39, 0.12);\n}\n.vx-cmd__actions {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  font-size: 12px;\n  color: var(--mute);\n}\n.vx-cmd__export {\n  padding: 6px 10px;\n  border-radius: 8px;\n  box-shadow: inset 0 0 0 1px var(--line-2);\n  color: var(--ink);\n}\n.vx-cmd__grid {\n  display: grid;\n  grid-template-columns: 1fr;\n}\n.vx-cmd__cell {\n  padding: 20px;\n  border-bottom: 1px solid var(--line);\n}\n@media (min-width: 960px) {\n  .vx-cmd__grid {\n    grid-template-columns: 1.6fr 1fr;\n  }\n  .vx-cmd__cell:nth-child(odd) {\n    border-right: 1px solid var(--line);\n  }\n  .vx-cmd__cell--recent {\n    grid-column: 1 / -1;\n    border-right: 0 !important;\n  }\n}\n.vx-funnel {\n  width: 100%;\n  overflow: visible;\n}\n.vx-funnel__s {\n  fill: none;\n  stroke-linecap: round;\n}\n.vx-funnel__s--sched {\n  stroke: var(--ink);\n  stroke-width: 26;\n}\n.vx-funnel__s--done {\n  stroke: var(--ink);\n  stroke-width: 20;\n}\n.vx-funnel__s--lost {\n  stroke: var(--line-2);\n  stroke-width: 5;\n}\n.vx-funnel__s--pass {\n  stroke: var(--sig);\n  stroke-width: 9;\n}\n.vx-funnel__s--fail {\n  stroke: var(--mute);\n  stroke-width: 11;\n}\n.vx-funnel text,\n.vx-life text {\n  font-family: var(--f-mono);\n  font-size: 9.5px;\n  letter-spacing: 0.06em;\n  fill: var(--ink-2);\n}\n.vx-funnel text.is-dim,\n.vx-life text.is-dim {\n  fill: var(--mute);\n}\n.vx-funnel text.is-pass,\n.vx-life text.is-pass {\n  fill: var(--sig-ink);\n}\n.vx-life text.is-warn {\n  fill: var(--warn);\n}\n.vx-activity {\n  width: 100%;\n  height: 120px;\n  overflow: visible;\n}\n.vx-activity path {\n  fill: none;\n  stroke-width: 2;\n  vector-effect: non-scaling-stroke;\n}\n.vx-activity__a {\n  stroke: var(--line-2);\n}\n.vx-activity__b {\n  stroke: var(--sig);\n}\n.vx-donut {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n}\n.vx-donut svg {\n  width: 110px;\n  height: 110px;\n}\n.vx-donut__s {\n  fill: none;\n  stroke-width: 12;\n}\n.vx-donut__s--0,\n.vx-donut__k--0 {\n  stroke: var(--sig);\n  background: var(--sig);\n}\n.vx-donut__s--1,\n.vx-donut__k--1 {\n  stroke: var(--ink);\n  background: var(--ink);\n}\n.vx-donut__s--2,\n.vx-donut__k--2 {\n  stroke: var(--line-2);\n  background: var(--line-2);\n}\n.vx-donut ul {\n  display: grid;\n  gap: 6px;\n  font-size: 13px;\n}\n.vx-donut li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.vx-donut__k {\n  width: 10px;\n  height: 10px;\n  border-radius: 3px;\n}\n.vx-cal__head {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 8px;\n  font-size: 13px;\n  font-weight: 600;\n}\n.vx-cal__head .vx-mono {\n  color: var(--mute);\n  font-weight: 400;\n}\n.vx-cal__grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n  font-size: 12px;\n  text-align: center;\n}\n.vx-cal__grid b {\n  padding: 4px 0;\n  font-weight: 500;\n  color: var(--mute);\n  font-size: 10.5px;\n}\n.vx-cal__grid span {\n  position: relative;\n  display: grid;\n  place-items: center;\n  height: 32px;\n  border-radius: 8px;\n  color: var(--ink-2);\n}\n.vx-cal__grid span.is-today {\n  background: var(--ink);\n  color: var(--paper);\n}\n.vx-cal__grid em {\n  position: absolute;\n  bottom: 3px;\n  display: flex;\n  gap: 2px;\n}\n.vx-cal__grid em i {\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n}\n.vx-cal__grid .is-done {\n  background: var(--ink-2);\n}\n.vx-cal__grid .is-pass {\n  background: var(--sig);\n}\n.vx-cal__grid .is-sched {\n  background: var(--mute);\n}\n.vx-cal__grid .is-slot {\n  background: var(--warn);\n}\n.vx-row {\n  display: grid;\n  grid-template-columns: 1.1fr 1.2fr auto auto;\n  gap: 12px;\n  align-items: center;\n  padding: 10px 0;\n  border-top: 1px solid var(--line);\n  font-size: 14px;\n}\n.vx-row span {\n  color: var(--mute);\n}\n.vx-row__view {\n  color: var(--ink) !important;\n  font-weight: 500;\n}\n.vx-status {\n  padding: 3px 9px;\n  border-radius: 99px;\n  font-size: 12px;\n  font-weight: 600;\n  background: var(--paper-2);\n}\n.vx-status.is-pass {\n  background: var(--sig-soft);\n  color: var(--sig-ink) !important;\n}\n.vx-status.is-live {\n  color: var(--warn) !important;\n}\n@media (max-width: 640px) {\n  .vx-row {\n    grid-template-columns: 1fr auto;\n  }\n  .vx-row > span:nth-child(2),\n  .vx-row__view {\n    display: none;\n  }\n}\n\n/* Scheduling */\n.vx-sched {\n  display: grid;\n  gap: 40px;\n  margin-top: clamp(80px, 10vw, 140px);\n  align-items: center;\n}\n.vx-sched__steps {\n  display: grid;\n  gap: 0;\n  margin: 28px 0 20px;\n  border-top: 1px solid var(--line-2);\n}\n.vx-sched__steps li {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 2px 18px;\n  padding: 14px 0;\n  border-bottom: 1px solid var(--line-2);\n}\n.vx-sched__steps .vx-mono {\n  grid-row: span 2;\n  color: var(--mute);\n  font-size: 11px;\n  padding-top: 3px;\n}\n.vx-sched__steps strong {\n  font-weight: 600;\n}\n.vx-sched__steps span:last-child {\n  font-size: 14px;\n  color: var(--mute);\n}\n.vx-slots {\n  padding: 22px;\n  border-radius: 22px;\n  background: var(--card);\n  box-shadow:\n    inset 0 0 0 1px var(--line),\n    0 40px 80px -60px rgba(17, 24, 39, 0.5);\n}\n.vx-slots__head {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n.vx-tz {\n  font-size: 12px;\n  color: var(--mute);\n}\n.vx-tz b {\n  color: var(--ink);\n  font-weight: 600;\n}\n.vx-slots__grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n.vx-slots__col {\n  display: grid;\n  gap: 6px;\n}\n.vx-slots__col b {\n  font-size: 12px;\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n.vx-slot {\n  position: relative;\n  padding: 9px 0;\n  border-radius: 10px;\n  text-align: center;\n  font-family: var(--f-mono);\n  font-size: 12.5px;\n  box-shadow: inset 0 0 0 1px var(--line);\n  transition:\n    color 0.3s,\n    background-color 0.3s;\n}\n.vx-slot.is-picked {\n  color: var(--ink);\n  font-weight: 500;\n}\n.vx-slot.is-locked {\n  background: var(--ink);\n  color: var(--paper);\n}\n.vx-slot__ring {\n  position: absolute;\n  inset: -2px;\n  border-radius: 12px;\n  box-shadow: 0 0 0 2px var(--sig);\n}\n.vx-slots__foot {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 16px;\n  font-size: 13px;\n  color: var(--mute);\n}\n.vx-slots__confirm {\n  padding: 8px 14px;\n  border-radius: 10px;\n  background: var(--paper-2);\n  color: var(--mute);\n  font-weight: 600;\n  transition:\n    background-color 0.3s,\n    color 0.3s;\n}\n.vx-slots__confirm.is-on {\n  background: var(--sig);\n  color: #fff;\n}\n@media (min-width: 960px) {\n  .vx-sched {\n    grid-template-columns: 0.9fr 1.1fr;\n    gap: 6vw;\n  }\n}\n\n/* Lifecycle */\n.vx-life {\n  margin-top: clamp(80px, 10vw, 140px);\n}\n.vx-life__scroll {\n  margin: 32px calc(var(--gutter) * -1) 18px;\n  padding: 0 var(--gutter);\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n.vx-life__svg {\n  display: block;\n  width: 100%;\n  min-width: 760px;\n  overflow: visible;\n}\n.vx-life path {\n  fill: none;\n  stroke-linecap: round;\n}\n.vx-life__main {\n  stroke: var(--ink);\n  stroke-width: 2;\n}\n.vx-life__loop,\n.vx-life__resched {\n  stroke: var(--warn);\n  stroke-width: 1.5;\n  stroke-dasharray: 5 6;\n}\n.vx-life__pass {\n  stroke: var(--sig);\n  stroke-width: 2;\n}\n.vx-life__fail {\n  stroke: var(--mute);\n  stroke-width: 2;\n}\n.vx-life__exp {\n  stroke: var(--line-2);\n  stroke-width: 1.5;\n}\n.vx-life__node {\n  fill: var(--paper-2);\n  stroke: var(--ink);\n  stroke-width: 2;\n}\n.vx-life__node--warn {\n  stroke: var(--warn);\n}\n.vx-life__token {\n  fill: var(--sig);\n  filter: drop-shadow(0 0 6px var(--sig));\n}\n\n/* Connection */\n.vx-chapter--connect {\n  background: var(--paper);\n}\n.vx-ats {\n  display: grid;\n  gap: 28px;\n  align-items: center;\n}\n.vx-ats__host {\n  border-radius: 20px;\n  background: var(--paper-2);\n  box-shadow: inset 0 0 0 1px var(--line-2);\n  overflow: hidden;\n}\n.vx-window__chrome--host {\n  background: var(--card);\n}\n.vx-ats__body {\n  display: grid;\n  grid-template-columns: 130px 1fr;\n  min-height: 260px;\n}\n.vx-ats__side {\n  display: grid;\n  align-content: start;\n  gap: 4px;\n  padding: 16px 12px;\n  border-right: 1px solid var(--line);\n  font-size: 13px;\n  color: var(--mute);\n}\n.vx-ats__side b {\n  margin-bottom: 10px;\n  font-family: var(--f-mono);\n  font-size: 11px;\n  letter-spacing: 0.12em;\n  color: var(--ink);\n}\n.vx-ats__side span {\n  padding: 6px 8px;\n  border-radius: 8px;\n}\n.vx-ats__side span.is-on {\n  background: var(--card);\n  color: var(--ink);\n  font-weight: 600;\n}\n.vx-ats__frame {\n  position: relative;\n  margin: 18px;\n  padding: 34px 18px 18px;\n  border-radius: 14px;\n  background: var(--card);\n  box-shadow:\n    0 0 0 1.5px var(--sig),\n    0 30px 60px -40px rgba(67, 97, 238, 0.6);\n}\n.vx-ats__tag {\n  position: absolute;\n  top: -1px;\n  left: 14px;\n  padding: 3px 9px;\n  border-radius: 0 0 8px 8px;\n  background: var(--sig);\n  color: #fff;\n  font-family: var(--f-mono);\n  font-size: 10.5px;\n}\n.vx-ats__mini {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.vx-ats__mini span {\n  display: flex;\n  flex-direction: column;\n  font-size: 14px;\n}\n.vx-ats__mini small {\n  color: var(--mute);\n  font-size: 12px;\n}\n.vx-ats__mini > b {\n  margin-left: auto;\n  font-size: 30px;\n  letter-spacing: -0.04em;\n}\n.vx-ats__skeleton {\n  display: grid;\n  gap: 8px;\n  margin-top: 18px;\n}\n.vx-ats__skeleton i {\n  height: 8px;\n  border-radius: 8px;\n  background: var(--paper-2);\n}\n.vx-ats__skeleton i:nth-child(2) {\n  width: 80%;\n}\n.vx-ats__skeleton i:nth-child(3) {\n  width: 60%;\n}\n.vx-handshake {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid var(--line);\n  background: var(--card);\n  font-family: var(--f-mono);\n  font-size: 11px;\n  color: var(--mute);\n}\n.vx-handshake i {\n  width: 18px;\n  height: 1px;\n  background: var(--line-2);\n}\n.vx-handshake .is-ok {\n  color: var(--sig-ink);\n}\n.vx-ats__out {\n  display: grid;\n  gap: 16px;\n}\n.vx-pipe {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n.vx-pipe li {\n  position: relative;\n  padding: 10px 16px;\n  border-radius: 99px;\n  box-shadow: inset 0 0 0 1px var(--line-2);\n  font-weight: 600;\n  font-size: 14px;\n}\n.vx-pipe li:not(:last-child)::after {\n  content: '→';\n  margin-left: 14px;\n  color: var(--mute);\n}\n.vx-pipe li.is-ok {\n  background: var(--sig);\n  color: #fff;\n  box-shadow: none;\n}\n.vx-payload {\n  padding: 18px;\n  border-radius: 16px;\n  background: var(--night);\n  color: #e5e7eb;\n  font-size: 12px;\n  line-height: 1.7;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n@media (min-width: 960px) {\n  .vx-ats {\n    grid-template-columns: 1.15fr 0.85fr;\n    gap: 4vw;\n  }\n}\n.vx-team {\n  display: grid;\n  gap: 32px;\n  align-items: center;\n  margin-top: clamp(80px, 10vw, 140px);\n}\n.vx-list {\n  display: grid;\n  margin-top: 24px;\n  border-top: 1px solid var(--line-2);\n}\n.vx-list li {\n  padding: 13px 0;\n  border-bottom: 1px solid var(--line-2);\n  font-size: 15px;\n  color: var(--ink-2);\n}\n.vx-team__svg {\n  width: 100%;\n  max-width: 600px;\n  justify-self: center;\n  overflow: visible;\n}\n.vx-team__ring {\n  fill: none;\n  stroke: var(--line-2);\n  stroke-dasharray: 3 5;\n}\n.vx-team__ring--0 {\n  fill: var(--sig-soft);\n  stroke: rgba(67, 97, 238, 0.4);\n}\n.vx-team__edge {\n  stroke: var(--ink);\n  stroke-width: 1.2;\n}\n.vx-team__assign {\n  stroke: var(--sig);\n  stroke-width: 1.2;\n  stroke-dasharray: 3 3;\n}\n.vx-team__node {\n  fill: var(--card);\n  stroke: var(--ink);\n  stroke-width: 2;\n}\n.vx-team__node.is-big {\n  fill: var(--ink);\n}\n.vx-team__label {\n  font-size: 11px;\n  font-weight: 600;\n  fill: var(--ink);\n}\n.vx-team__scope {\n  font-family: var(--f-mono);\n  font-size: 9px;\n  fill: var(--sig-ink);\n}\n.vx-team__job {\n  fill: var(--card);\n  stroke: var(--sig);\n}\n.vx-team__jobt {\n  font-family: var(--f-mono);\n  font-size: 10px;\n  fill: var(--sig-ink);\n}\n@media (min-width: 960px) {\n  .vx-team {\n    grid-template-columns: 0.8fr 1.2fr;\n    gap: 6vw;\n  }\n}\n\n/* Proof */\n.vx-proof {\n  background: var(--paper);\n  border-top: 1px solid var(--line);\n}\n.vx-proof__list {\n  position: relative;\n  border-top: 1px solid var(--line-2);\n}\n.vx-proof__item {\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  gap: 4px 20px;\n  align-items: baseline;\n  padding: clamp(16px, 2.2vw, 26px) 0;\n  border-bottom: 1px solid var(--line-2);\n  transition:\n    opacity 0.4s,\n    color 0.4s;\n}\n.vx-proof__item.is-dim {\n  opacity: 0.28;\n}\n.vx-proof__n {\n  color: var(--mute);\n}\n.vx-proof__name {\n  font-size: clamp(2.2rem, 6.4vw, 6.4rem);\n  font-weight: 600;\n  letter-spacing: -0.055em;\n  line-height: 0.95;\n  transition:\n    transform 0.6s var(--ease),\n    color 0.4s;\n}\n.vx-proof__item.is-on .vx-proof__name {\n  transform: translateX(16px);\n  color: var(--sig-ink);\n}\n.vx-proof__note {\n  grid-column: 2;\n  font-size: 15px;\n  color: var(--mute);\n}\n.vx-proof__inline {\n  grid-column: 2;\n  margin-top: 10px;\n}\n.vx-proof__float {\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 3;\n  width: 300px;\n  margin: 20px 0 0 20px;\n  pointer-events: none;\n}\n.vx-prev {\n  display: grid;\n  gap: 10px;\n  padding: 16px;\n  border-radius: 16px;\n  background: var(--card);\n  box-shadow:\n    inset 0 0 0 1px var(--line),\n    0 30px 60px -30px rgba(17, 24, 39, 0.55);\n  font-size: 13px;\n}\n.vx-prev p b {\n  margin-right: 6px;\n  font-size: 11px;\n  color: var(--mute);\n}\n.vx-prev p.is-cand {\n  color: var(--ink-2);\n}\n.vx-prev .vx-mono {\n  color: var(--sig-ink);\n}\n.vx-prev--s strong {\n  font-size: 54px;\n  letter-spacing: -0.06em;\n  line-height: 0.9;\n}\n.vx-prev--s small {\n  font-size: 15px;\n  color: var(--mute);\n  letter-spacing: 0;\n}\n.vx-prev--c code {\n  padding: 8px 10px;\n  border-radius: 8px;\n  background: var(--night);\n  color: var(--sig-bright);\n  font-size: 12px;\n}\n.vx-prev--i ul {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 4px 12px;\n  color: var(--mute);\n}\n.vx-prev--i b {\n  color: var(--ink);\n  float: right;\n}\n.vx-prev__screen {\n  display: grid;\n  place-items: center;\n  aspect-ratio: 16 / 8;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #1c2029, #111827);\n  color: var(--night-text);\n}\n.vx-prev .vx-player__scrub {\n  margin: 0;\n}\n@media (pointer: fine) and (min-width: 960px) {\n  .vx-proof__inline {\n    display: none;\n  }\n  .vx-proof__item {\n    grid-template-columns: 60px 1fr minmax(0, 0.5fr);\n  }\n  .vx-proof__note {\n    grid-column: 3;\n    text-align: right;\n  }\n}\n@media not ((pointer: fine) and (min-width: 960px)) {\n  .vx-proof__float {\n    display: none;\n  }\n  .vx-proof__inline .vx-prev {\n    max-width: 380px;\n    box-shadow: inset 0 0 0 1px var(--line);\n  }\n}\n\n/* Decision */\n.vx-decision {\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 140px var(--gutter) 90px;\n  background: var(--night);\n  color: var(--night-text);\n  overflow: hidden;\n  isolation: isolate;\n}\n.vx-decision__orb {\n  position: absolute;\n  right: -12vw;\n  top: 50%;\n  width: min(70vw, 900px);\n  aspect-ratio: 1;\n  translate: 0 -50%;\n  z-index: -1;\n  opacity: 0.9;\n}\n.vx-decision__title {\n  display: flex;\n  flex-direction: column;\n  margin: 24px 0 40px;\n  font-size: clamp(2.9rem, 8.6vw, 9.6rem);\n  font-weight: 600;\n  line-height: 0.9;\n  letter-spacing: -0.06em;\n}\n.vx-decision__line {\n  display: block;\n}\n.vx-decision__line.vx-serif {\n  letter-spacing: -0.035em;\n}\n.vx-decision__foot {\n  display: grid;\n  gap: 26px;\n  max-width: 560px;\n}\n.vx-decision__ctas {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px 26px;\n  align-items: center;\n}\n.vx-decision__note {\n  font-size: 13px;\n  color: var(--night-mute);\n}\n.vx-footer {\n  padding: 40px var(--gutter) 28px;\n  background: var(--night);\n  color: var(--night-text);\n  border-top: 1px solid var(--night-line);\n}\n.vx-footer__row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 18px;\n}\n.vx-footer__row--small {\n  margin-top: 28px;\n  font-size: 13px;\n  color: var(--night-mute);\n}\n.vx-footer__links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 22px;\n  font-size: 14px;\n  color: var(--night-mute);\n}\n.vx-footer__links a:hover {\n  color: var(--night-text);\n}\n\n/* ---------------------------- Reduced motion ---------------------------- */\n\n@media (prefers-reduced-motion: reduce) {\n  .vx *,\n  .vx *::before,\n  .vx *::after {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.2s !important;\n  }\n  .vx-dot--live::after {\n    display: none;\n  }\n}\n\n/* ------------------------- Narrow-screen fixes -------------------------- */\n\n.vx-nav__product {\n  white-space: nowrap;\n}\n.vx-meet,\n.vx-meet__main,\n.vx-meet__top,\n.vx-workspace,\n.vx-workspace__editor,\n.vx-observe,\n.vx-report {\n  min-width: 0;\n}\n.vx-life__list {\n  display: none;\n}\n@media (max-width: 760px) {\n  .vx-life__scroll {\n    display: none;\n  }\n  .vx-life__list {\n    display: grid;\n    margin: 28px 0 18px;\n    padding-left: 18px;\n    border-left: 2px solid var(--ink);\n  }\n  .vx-life__list li {\n    position: relative;\n    display: grid;\n    gap: 2px;\n    padding: 10px 0 10px 14px;\n  }\n  .vx-life__list li::before {\n    content: '';\n    position: absolute;\n    left: -25px;\n    top: 15px;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: var(--paper-2);\n    box-shadow: inset 0 0 0 2px var(--ink);\n  }\n  .vx-life__list li.is-branch {\n    margin-left: 18px;\n    padding-left: 14px;\n    border-left: 1px dashed var(--line-2);\n  }\n  .vx-life__list li.is-branch::before {\n    left: -44px;\n  }\n  .vx-life__list b {\n    font-family: var(--f-mono);\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n  }\n  .vx-life__list li.is-warn b {\n    color: var(--warn);\n  }\n  .vx-life__list li.is-warn::before {\n    box-shadow: inset 0 0 0 2px var(--warn);\n  }\n  .vx-life__list li.is-pass b {\n    color: var(--sig-ink);\n  }\n  .vx-life__list li.is-pass::before {\n    background: var(--sig);\n    box-shadow: none;\n  }\n  .vx-life__list span {\n    font-size: 14px;\n    color: var(--mute);\n  }\n  .vx-meet__q,\n  .vx-meet__timer {\n    display: none;\n  }\n  .vx-meet__top {\n    flex-wrap: wrap;\n  }\n  .vx-decision__orb {\n    opacity: 0.45;\n    width: 120vw;\n    right: -50vw;\n  }\n}\n@media (max-width: 400px) {\n  .vx-nav__product {\n    display: none;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
